export default class ActionsControl {
    constructor(options) {
        // input parameters
        this.objectType = options.objectType;
        this.objectId = options.objectId;
        this.localization = options.localization;
        this.fieldsFilterItem = options.fieldsFilterItem;
        this.fieldsTreeItem = options.fieldsTreeItem;
        this.fieldsDefinitionItem = options.fieldsDefinitionItem;
        this.layoutTemplateWrapper = options.layoutTemplateWrapper;
        this.uiFieldsControl = options.uiFieldsControl;
        this.type = options.type;
        this.subType = options.subType;
        this.elementActions = options.elementActions;
        this.generalActions = options.generalActions;
        this.uniqueId = 'actionsControl' + this._generateUUID();
        this.optionsModalId = this.uniqueId + '-options-modal';

        // definition action properties
        this.actionTitle = this.fieldsDefinitionItem + 'action-title';
        this.actionText = this.fieldsDefinitionItem + 'action-text';
        this.actionTooltip = this.fieldsDefinitionItem + 'action-tooltip';
        this.actionIcon = this.fieldsDefinitionItem + 'action-icon';
        this.actionMobileIcon = this.fieldsDefinitionItem + 'action-mobile-icon';
        this.actionForm = this.fieldsDefinitionItem + 'action-form';
        this.actionGeomField = this.fieldsDefinitionItem + 'action-geom-field';
        this.actionPermissionType = this.fieldsDefinitionItem + 'action-permission-type';
        this.actionPlatforms = this.fieldsDefinitionItem + 'action-platforms';
        this.actionFormWfForm = this.fieldsDefinitionItem + 'action-form-wf-form';
        this.actionFormWfFormFields = this.fieldsDefinitionItem + 'action-form-wf-form-fields';
        this.actionType = this.fieldsDefinitionItem + 'action-type';
        this.actionPermissionSubType = this.fieldsDefinitionItem + 'action-permission-sub-type';
        this.actionSubForm = this.fieldsDefinitionItem + 'action-sub-form';
        this.actionSubFormIdForm = this.fieldsDefinitionItem + 'action-sub-form-id-form';
        this.actionSubFormIdPkVal = this.fieldsDefinitionItem + 'action-sub-form-id-pk-val';
        this.actionFormIdPkVal = this.fieldsDefinitionItem + 'action-form-id-pk-val';
        this.actionList = this.fieldsDefinitionItem + 'action-list';
        this.actionUrl = this.fieldsDefinitionItem + 'action-url';
        this.actionJs = this.fieldsDefinitionItem + 'action-js';
        this.actionClassName = this.fieldsDefinitionItem + 'action-class-name';
        this.actionStyle = this.fieldsDefinitionItem + 'action-style';
        this.actionMaxSelection = this.fieldsDefinitionItem + 'action-max-selection';
        this.actionMinSelection = this.fieldsDefinitionItem + 'action-min-selection';
        this.actionNormalForm = this.fieldsDefinitionItem + 'action-normal-form';
        this.actionNewRecord = this.fieldsDefinitionItem + 'action-new-record';
        this.actionHtmlAttributes = this.fieldsDefinitionItem + 'action-html-attributes';
        this.actionNewFormMappings = this.fieldsDefinitionItem + 'action-new-form-mappings';
        this.layoutTemplateInner = this.fieldsDefinitionItem + 'layout-template-inner';
        this.actionPlugin = this.fieldsDefinitionItem + 'action-plugin';
        this.actionDashboard = this.fieldsDefinitionItem + 'action-dashboard';
        this.actionReport = this.fieldsDefinitionItem + 'action-report';
        this.actionTimelineType = this.fieldsDefinitionItem + 'action-timeline-type';
        this.ActionTimelineUnit = this.fieldsDefinitionItem + 'action-timeline-unit';
        this.actionTimelineStart = this.fieldsDefinitionItem + 'action-timeline-start';
        this.actionTimelineEnd = this.fieldsDefinitionItem + 'action-timeline-end';
        this.actionTimelineFormat = this.fieldsDefinitionItem + 'action-timeline-format';
        this.actionTimelineLoop = this.fieldsDefinitionItem + 'action-timeline-loop';
        this.actionTimelineSelectorType = this.fieldsDefinitionItem + 'action-timeline-selector-type';
        this.actionTimelineBackground = this.fieldsDefinitionItem + 'action-timeline-background';
        this.actionTimelineSpeed = this.fieldsDefinitionItem + 'action-timeline-speed';
        this.actionTimelineIntervalType = this.fieldsDefinitionItem + 'action-timeline-interval-type';
        this.actionTimelineIntervalPeriodType = this.fieldsDefinitionItem + 'action-timeline-interval-period-type';
        this.actionTimelineIntervalPeriodLength = this.fieldsDefinitionItem + 'action-timeline-interval-period-length';
        this.actionTimelineThumb = this.fieldsDefinitionItem + 'action-timeline-thumb';
        this.actionTimelineChannel = this.fieldsDefinitionItem + 'action-timeline-channel';
        this.actionFollowZoom = this.fieldsDefinitionItem + 'action-follow-zoom';
        this.actionFollowDisable = this.fieldsDefinitionItem + 'action-follow-disable';
        this.actionFollowEnabled = this.fieldsDefinitionItem + 'action-follow-enabled';
        this.actionAnalysisOperatorType = this.fieldsDefinitionItem + 'action-analysis-operator-type';
        this.actionPrintingPageType = this.fieldsDefinitionItem + 'action-printing-page-type';
        this.actionPrintingPageOrientation = this.fieldsDefinitionItem + 'action-printing-page-orientation';
        this.actionPrintingTemplate = this.fieldsDefinitionItem + 'action-printing-template';
        this.actionAnalysisBuffer = this.fieldsDefinitionItem + 'action-analysis-buffer';
        this.actionAnalysisResultType = this.fieldsDefinitionItem + 'action-analysis-result-type';
        this.actionAnalysisLayers = this.fieldsDefinitionItem + 'action-analysis-layers';
        this.actionAnalysisTemplateSelect = this.fieldsDefinitionItem + 'action-analysis-template-select';
        this.actionAnalysisMainTemplateHeader = this.fieldsDefinitionItem + 'action-analysis-main-template-header';
        this.actionAnalysisMainTemplateFooter = this.fieldsDefinitionItem + 'action-analysis-main-template-footer';
        this.actionAnalysisSelectorStyle = this.fieldsDefinitionItem + 'action-analysis-selector-style';
        this.actionAnalysisResultStyle = this.fieldsDefinitionItem + 'action-analysis-result-style';
        this.actionAnalysisQuickSearch = this.fieldsDefinitionItem + 'action-analysis-quick-search';
        this.actionLoadOnStart = this.fieldsDefinitionItem + 'action-load-on-start';
        this.actionModalHeight = this.fieldsDefinitionItem + 'action-modal-height';
        this.actionModalWidth = this.fieldsDefinitionItem + 'action-modal-width';
        this.actionAlwaysModal = this.fieldsDefinitionItem + 'action-always-modal';
        this.actionShowInQuickLegend = this.fieldsDefinitionItem + 'action-show-in-quick-legend';

        // control properties
        this.index = 2;
        this.isTreeInitialized = false;
        this.selectedField = null;
        this.selectedFieldShown = false;
        this.selectedFieldInitialized = false;
        this.maxLayoutAttribute = 10;
        this.actionDynamicContent = this.fieldsDefinitionItem + 'dynamic-type-content';
        this.actionDynamicContentForm = this.fieldsDefinitionItem + 'dynamic-type-content-form';
        this.actionDynamicContentFormId = this.fieldsDefinitionItem + 'dynamic-type-content-form-id';

        this.jsEditor = null;
        this.htmlMainEditorHeader = null;
        this.htmlMainEditorFooter = null;
        this.hasErrors = false;
        this.htmlPrintingTemplate = null;

        window[this.uniqueId] = this;

        this.initControl();
    }

    _editTemplateInfo = null;

    initControl() {
        if (this.type == 'mapLayer') {
            if (this.uiFieldsControl == null) {
                this.uiFieldsControl = {
                    actionSubFormIdPkVal: 'IdFieldTarget',
                    actionSubFormIdForm: 'IdFormFieldTarget'
                };
            }
        }

        $('body').on('click', (evt) => {
            $('#' + this.optionsModalId).hide();
        });

        $('#' + this.fieldsTreeItem).parent().parent().parent().parent()
            .append(`<div id="` + this.optionsModalId + `" style="display: none; position:absolute; width: 200px; z-index: 100000; border-radius: 5px; background-color: #fff; border-bottom: 1px solid #e0e0e0; box-shadow: 0px 0px 13px 0px rgba(62, 44, 90, 0.08);">                    
                    </div>`);

        this.initTree();
        this.initEvents();
    }

    refreshControl() {
        this.isTreeInitialized = false;
        let parent = $('#actions-tree-control').parent();
        $('#actions-tree-control').remove();
        parent.append('<div id="actions-tree-control" style="border:none !important; position: absolute; padding-top: 0; width: 100%;"></div>');
        this.initTree();
    }

    initTree() {
        if (!this.isTreeInitialized) {
            let actionNodeList = [];
            if (this.type == 'list' || this.type == 'layer' || this.type == 'mapLayer') {
                actionNodeList.push({
                    index: 1,
                    isParent: true,
                    displayText: this.getResource('GeneralActions'),
                    type: 'parent_general',
                    Items: []
                });

                actionNodeList.push({
                    index: 2,
                    isParent: true,
                    displayText: this.getResource('ElementActions'),
                    type: 'parent_element',
                    Items: []
                });
            } else if (this.type == 'application' || this.type == 'map') {
                actionNodeList.push({
                    index: 1,
                    isParent: true,
                    displayText: this.getResource('GeneralActions'),
                    type: 'parent_general',
                    Items: []
                });
            } else {
                actionNodeList.push({
                    index: 2,
                    isParent: true,
                    displayText: this.getResource('ElementActions'),
                    type: 'parent_element',
                    Items: []
                });
            }



            let dataSource = new kendo.data.HierarchicalDataSource({
                data: actionNodeList, schema: {
                    model: {
                        id: "index",
                        children: "Items"
                    }
                }
            });

            $('#' + this.fieldsTreeItem).kendoTreeView({
                template: (item) => { return this._getActionNodeTemplate(item); },
                checkboxes: {
                    name: 'checked'
                },
                dragAndDrop: true,
                dragend: (e) => {
                    this.filterTree();
                },
                loadOnDemand: false,
                dataSource: dataSource,
                dataTextField: "displayText",
                dataValueField: "index",
                select: (e) => {
                    this.selectField(e);
                },
                check: (e) => {
                    loadPreview();
                }
            });
            $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');
            this.loadItems();
            this.isTreeInitialized = true;
            if (!this.hasErrors) {
                $('#tabActionsSel').removeClass('form-fields-tab-error');

                if (this.type == 'map' || this.type == 'app') {
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('span').css('color', '#333');
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('i').css('color', '#333');
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('span').css('font-weight', '500');
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('i').css('font-weight', '500');
                }
            }
        } else {
            let actionNodeList = [];
            if (this.type == 'list' || this.type == 'layer' || this.type == 'mapLayer') {
                actionNodeList.push({
                    index: 1,
                    isParent: true,
                    displayText: this.getResource('GeneralActions'),
                    type: 'parent_general',
                    Items: []
                });

                actionNodeList.push({
                    index: 2,
                    isParent: true,
                    displayText: this.getResource('ElementActions'),
                    type: 'parent_element',
                    Items: []
                });
            } else if (this.type == 'application' || this.type == 'map') {
                actionNodeList.push({
                    index: 1,
                    isParent: true,
                    displayText: this.getResource('GeneralActions'),
                    type: 'parent_general',
                    Items: []
                });
            } else {
                actionNodeList.push({
                    index: 2,
                    isParent: true,
                    displayText: this.getResource('ElementActions'),
                    type: 'parent_element',
                    Items: []
                });
            }

            let dataSource = new kendo.data.HierarchicalDataSource({
                data: actionNodeList, schema: {
                    model: {
                        id: "index",
                        children: "Items"
                    }
                }
            });

            $('#' + this.fieldsTreeItem).data('kendoTreeView').setDataSource(dataSource);
            $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');
            this.loadItems();
            $('#' + this.fieldsDefinitionItem)[0].innerHTML = '';
            this.selectedField = null;
            if (!this.hasErrors) {
                $('#tabActionsSel').removeClass('form-fields-tab-error');

                if (this.type == 'map' || this.type == 'application') {
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('span').css('color', '#333');
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('i').css('color', '#333');
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('span').css('font-weight', '500');
                    $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('i').css('font-weight', '500');
                }
            }
        }
    }

    _getActionNodeTemplate(node) {
        let item = node.item;
        let template = ``;
        let currentErrors = null;

        if (item.storedItem != null && item.storedItem.InvalidProperties != null && item.storedItem.InvalidProperties.length > 0) {
            this.hasErrors = true;
            currentErrors = '';
            $('#tabActionsSel').addClass('form-fields-tab-error');
            item.storedItem.InvalidProperties.forEach(error => {
                currentErrors += error.Message + '\n';
            });

            if (this.type == 'map' || this.type == 'application') {
                $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('span').css('color', '#FF5733');
                $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('i').css('color', '#FF5733');
                $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('span').css('font-weight', '600');
                $('#' + this.fieldsTreeItem).closest('.panel').find('.panel-hdr').find('i').css('font-weight', '600');
            }
        }

        if (item.isParent) {
            template = `<div><span class="field-display-text tree-parent-action">` + item.displayText + `</span></div>`;
            if (item.type == 'parent_general') {
                template += `<button class="general-parent-node fal fa-plus btn-primary" onclick="` + this.uniqueId + `.addGeneralAction(event)"></button>`;
            } else {
                template += `<button class="general-parent-node fal fa-plus btn-primary" onclick="` + this.uniqueId + `.addElementAction(event)"></button>`;
            }
        } else if (item.type.indexOf('DYNAMIC') >= 0) {
            if (currentErrors != null) {
                template = `<div title="` + currentErrors + `" class="error-tree-node"><span class="error-tree-node field-display-text tree-dynamic-action"` + (item.subType == 'SEPARATOR' ? ` style="font-weight: bold;"` : ``) + `>` + item.displayText + `<i class="ml-2 fal fa-exclamation-circle" style="font-weight: bold;"></i></span></div>`;
            } else {
                template = `<div><span class="field-display-text tree-dynamic-action"` + (item.subType == 'SEPARATOR' ? ` style="font-weight: bold;"` : ``) + `>` + item.displayText + `</span></div>`;
            }

            if (item.subType == 'GROUP' && item.type == 'DYNAMIC_GENERAL') {
                template += `<button class="general-parent-node fal fa-plus btn-primary" onclick="` + this.uniqueId + `.addGeneralAction(event)"></button>`;
            } else if (item.subType == 'GROUP' && item.type == 'DYNAMIC_ELEMENT') {
                template += `<button class="general-parent-node fal fa-plus btn-primary" onclick="` + this.uniqueId + `.addElementAction(event)"></button>`;
            }

            template += `<div class="tree-item-remove fal fa-trash-alt" onclick="` + this.uniqueId + `.removeDynamicAction(event, this)" style="line-height: 1.2rem; width: 1.2rem; text-align: center; right: 0.4rem;"></div>`;
        } else {
            if (currentErrors != null) {
                template = `<div title="` + currentErrors + `" class="error-tree-node"><span class="field-display-text">` + item.displayText + `<i class="ml-2 fal fa-exclamation-circle" style="font-weight: bold;"></i></span></div>`;
            } else {
                template = `<div><span class="field-display-text">` + item.displayText + `</span></div>`;
            }
        }

        return template;
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    addGeneralAction(evt) {
        evt.stopPropagation();
        if (this.type == 'application' || this.type == 'map') {
            let parentUid = $(evt.target).parent().parent().parent().attr('data-uid');
            this._showActionChoiceMenu(evt.target, parentUid, true);
        } else {
            let nodeData = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];
            let actionsNodeUid = nodeData.uid;
            let actionsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(actionsNodeUid);

            let action = {
                Type: 'DYNAMIC_GENERAL',
                Id: 0
            }

            $('#' + this.fieldsTreeItem).data("kendoTreeView").append({
                storedItem: action,
                index: ++this.index,
                displayText: 'Nedefinit',
                checked: true,
                details: '',
                Items: [],
                type: 'DYNAMIC_GENERAL',
                subType: null
            }, actionsNode);

            $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');

            let newUid = nodeData.children._data[nodeData.children._data.length - 1].uid;
            let newActionsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(newUid);

            $('#' + this.fieldsTreeItem).data("kendoTreeView").select(newActionsNode);
            this.selectNode(newActionsNode);
        }
    }

    _showActionChoiceMenu(anchor, parentUid, isGeneral) {
        $('#' + this.optionsModalId)[0].innerHTML = `<div class="action-menu-choice" action-type="action" action-location="` + (isGeneral ? `general` : `element`) + `" parent-uid="` + parentUid + `" style="padding: 0.75rem;">` + this.getResource('MenuAction') + `</div>
                        <div class="action-menu-choice" action-type="group" parent-uid="` + parentUid + `" action-location="` + (isGeneral ? `general` : `element`) + `" style="padding: 0.75rem;">` + this.getResource('ActionSubType_GROUP') + `</div>
                        <div class="action-menu-choice" action-type="separator" parent-uid="` + parentUid + `" action-location="` + (isGeneral ? `general` : `element`) + `" style="padding: 0.75rem;">` + this.getResource('ActionSubType_SEPARATOR') + `</div>`;

        $('.action-menu-choice').on('click', (evt) => {
            let type = $(evt.target).attr('action-type');
            let parentId = $(evt.target).attr('parent-uid');
            let actionLocation = $(evt.target).attr('action-location');

            let action = {
                Type: actionLocation == 'general' ? 'DYNAMIC_GENERAL' : 'DYNAMIC_ELEMENT',
                Id: 0,
                Items: [],
                Icon: 'fal fa-question',
                SubType: type == 'action' ? null : type == 'separator' ? 'SEPARATOR' : 'GROUP'
            };

            let parentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(parentId);

            let insertedNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").append({
                storedItem: action,
                index: ++this.index,
                displayText: type == 'action' ? 'Nedefinit' : type == 'separator' ? this.getResource('ActionSubType_SEPARATOR') : this.getResource('ActionSubType_GROUP'),
                checked: true,
                details: '',
                Items: [],
                type: actionLocation == 'general' ? 'DYNAMIC_GENERAL' : 'DYNAMIC_ELEMENT',
                subType: type == 'action' ? null : type == 'separator' ? 'SEPARATOR' : 'GROUP'
            }, parentNode);

            let insertedUid = $(insertedNode).attr('data-uid');

            $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
            $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');

            let newActionsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(insertedUid);

            $('#' + this.fieldsTreeItem).data("kendoTreeView").select(newActionsNode);
            this.selectNode(newActionsNode);

        });

        $('#' + this.optionsModalId).show();
        let y = anchor.getBoundingClientRect().top + anchor.getBoundingClientRect().height - $('#' + this.fieldsTreeItem).parent().parent().parent()[0].getBoundingClientRect().top;
        let x = anchor.getBoundingClientRect().left + anchor.getBoundingClientRect().width - $('#' + this.fieldsTreeItem).parent().parent().parent()[0].getBoundingClientRect().left;
        $('#' + this.optionsModalId).css('top', y + 'px');
        $('#' + this.optionsModalId).css('left', x + 'px');
    }

    addElementAction(evt) {
        evt.stopPropagation();
        let nodeData = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 2 })[0];
        let actionsNodeUid = nodeData.uid;
        let actionsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(actionsNodeUid);

        let action = {
            Type: 'DYNAMIC_ELEMENT',
            Id: 0,
            Icon: 'fal fa-question'
        }

        $('#' + this.fieldsTreeItem).data("kendoTreeView").append({
            storedItem: action,
            index: ++this.index,
            displayText: 'Nedefinit',
            checked: true,
            details: '',
            Items: [],
            type: 'DYNAMIC_ELEMENT',
            subType: null
        }, actionsNode);

        $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
        $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');

        let newUid = nodeData.children._data[nodeData.children._data.length - 1].uid;
        let newActionsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(newUid);

        $('#' + this.fieldsTreeItem).data("kendoTreeView").select(newActionsNode);
        this.selectNode(newActionsNode);
    }

    initEvents() {
        $('#' + this.fieldsFilterItem).on('input', (evt) => {
            this.filterTree();
        });
    }

    filterTree() {
        let searchFilter = {
            field: "displayText",
            operator: "contains",
            value: $('#' + this.fieldsFilterItem).val()
        };

        $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.filter(searchFilter);
        $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
        $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
        $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');
    }

    loadItems() {
        if (this.type == 'list' || this.type == 'layer' || this.type == 'mapLayer') {
            this.loadGeneralActions();
            this.loadElementActions();
        } else if (this.type == 'form') {
            this.loadElementActions();
        } else if (this.type == 'application' || this.type == 'map') {
            this.loadGeneralActions();
        }
    }

    loadGeneralActions() {
        let getGeneralActionsUrl = rootUrl + 'UIAction/GetGeneralActions?parentType=' + this.objectType + '&id=' + this.objectId;
        let data = {
            id: this.objectId
        };

        if (this.generalActions != null) {
            this.initActions(this.generalActions, 'general', 'GeneralAction_', 1);
            notifyGeneralActionsLoaded();
        } else {
            $.ajax({
                type: "POST",
                url: getGeneralActionsUrl,
                async: true,
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8",
                success: (generalActions) => {
                    this.initActions(generalActions, 'general', 'GeneralAction_', 1);
                    notifyGeneralActionsLoaded();
                },
                error: (e) => {
                    toastr.error(this.getResource('GetGeneralActionsError'));
                }
            });
        }
    }

    loadElementActions() {
        let getElementActionsUrl = rootUrl + 'UIAction/GetElementActions?parentType=' + this.objectType + '&id=' + this.objectId;
        let data = {
            id: this.objectId
        };

        if (this.elementActions != null) {
            this.initActions(this.elementActions, 'element', 'ElementAction_', 2);
            notifyElementActionsLoaded();
        } else {
            $.ajax({
                type: "POST",
                url: getElementActionsUrl,
                async: true,
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8",
                success: (elementActions) => {
                    this.initActions(elementActions, 'element', 'ElementAction_', 2);
                    notifyElementActionsLoaded();
                },
                error: (e) => {
                    toastr.error(this.getResource('GetGeneralActionsError'));
                }
            });
        }
    }

    getGeneralActions() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        if (!fieldParentNode.children.data) {
            return [];
        }
        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];

        if (fieldNodes != null) {
            fieldNodes.forEach(fieldNode => {
                if (fieldNode.checked) {
                    fieldData.push(fieldNode.storedItem);
                }
            });
        }

        return fieldData;
    }

    getAllGeneralActions() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        let fieldData = [];

        if (fieldParentNode.hasChildren) {

            let fieldNodes = fieldParentNode.children.data();

            fieldNodes.forEach(fieldNode => {
                if (fieldNode.checked) {
                    fieldNode.storedItem.Checked = true;
                    fieldData.push(fieldNode.storedItem);
                } else {
                    fieldNode.storedItem.Checked = false;
                    fieldData.push(fieldNode.storedItem);
                }
            });
        }

        return fieldData;
    }

    getElementActions() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 2 })[0];

        let fieldData = [];

        if (fieldParentNode.hasChildren) {
            let fieldNodes = fieldParentNode.children.data();

            fieldNodes.forEach(fieldNode => {
                if (fieldNode.checked) {
                    fieldData.push(fieldNode.storedItem);
                }
            });
        }

        return fieldData;
    }

    getAllElementActions() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 2 })[0];

        let fieldData = [];

        if (fieldParentNode.hasChildren) {
            let fieldNodes = fieldParentNode.children.data();

            fieldNodes.forEach(fieldNode => {
                if (fieldNode.checked) {
                    fieldNode.storedItem.Checked = true;
                    fieldData.push(fieldNode.storedItem);
                } else {
                    fieldNode.storedItem.Checked = false;
                    fieldData.push(fieldNode.storedItem);
                }
            });
        }

        return fieldData;
    }

    initActions(actions, type, typePrefix, parentId) {
        let actionsNodeUid = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == parentId })[0].uid;
        let actionsNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").findByUid(actionsNodeUid);

        actions.forEach(action => {
            let usePrefix = typePrefix;

            if (action.Type == 'DYNAMIC_GENERAL' || action.Type == 'DYNAMIC_ELEMENT') {
                usePrefix = 'ActionSubType_';
            }

            let currentNode = {
                storedItem: action,
                index: ++this.index,
                displayText: action.Type == 'DYNAMIC_GENERAL' || action.Type == 'DYNAMIC_ELEMENT' ? action.Text + ' (' + this.getResource(usePrefix + action.SubType) + ')' : this.getResource(usePrefix + action.SubType),
                checked: action.Checked != null ? action.Checked : action.Id > 0,
                details: null,
                type: action.Type,
                subType: action.SubType,
                Items: []
            }

            this.initChildActions(action, currentNode, typePrefix);

            $('#' + this.fieldsTreeItem).data("kendoTreeView").append(currentNode, actionsNode);
        });

        $('.tree-dynamic-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
        $('.tree-dynamic-action').closest('.k-in').css('padding-left', '1.8rem');
        $('#' + this.fieldsTreeItem).data('kendoTreeView').expand('.k-treeview-item');
        $('#map-actions-tree-control .k-treeview-lines').show();
        $('#map-actions-tree-control .k-i-loading').hide();
    }

    initChildActions(action, node, typePrefix) {
        if (action.Items != null && action.Items.length > 0) {
            action.Items.forEach(child => {
                let usePrefix = typePrefix;

                if (child.Type == 'DYNAMIC_GENERAL' || child.Type == 'DYNAMIC_ELEMENT') {
                    usePrefix = 'ActionSubType_';
                }

                var childNode = {
                    storedItem: child,
                    index: ++this.index,
                    displayText: child.Type == 'DYNAMIC_GENERAL' || child.Type == 'DYNAMIC_ELEMENT' ? child.Text + ' (' + this.getResource(usePrefix + child.SubType) + ')' : this.getResource(usePrefix + child.SubType),
                    checked: child.Checked != null ? child.Checked : child.Id > 0,
                    details: null,
                    type: child.Type,
                    subType: child.SubType,
                    Items: []
                }

                node.Items.push(childNode);
                this.initChildActions(child, childNode, typePrefix);
            });
        }
    }

    saveDetails() {
        if (this.selectedField != null) {
            switch (this.selectedField.type) {
                case 'STANDARD_GENERAL': this.saveGeneralDetails();
                    break;
                case 'DYNAMIC_GENERAL': this.saveGeneralDetails();
                    break;
                case 'STANDARD_ELEMENT': this.saveElementDetails();
                    break;
                case 'DYNAMIC_ELEMENT': this.saveElementDetails();
                    break;
                default: break;
            }
        }
    }
    getNumber(source) {
        if (source == null || source == '') {
            return null;
        }
        else {
            return new Number(source);
        }
    }
    destroyFieldDetails() {
        this.saveDetails();
        this.selectedField = null;
        this.selectedFieldShown = false;
        $('#' + this.fieldsDefinitionItem)[0].innerHTML = '';
    }

    removeDynamicAction(evt, element) {
        evt.stopPropagation();
        let selection = $(element).closest('[role="treeitem"]');

        $('#' + this.fieldsTreeItem).data('kendoTreeView').remove(selection);

        this.destroyFieldDetails();
    }

    selectField(item) {
        $('#' + this.fieldsTreeItem).focus();
        this.selectNode(item.node);
    }

    selectNode(node) {
        this.saveDetails();
        loadPreview();
        this.jsEditor = null;
        let selectedItem = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataItem(node);
        this.selectedField = selectedItem;
        this.selectedFieldShown = true;

        switch (selectedItem.type) {
            case 'STANDARD_GENERAL': this.selectGeneralNode(selectedItem);
                break;
            case 'DYNAMIC_GENERAL': this.selectGeneralNode(selectedItem);
                break;
            case 'STANDARD_ELEMENT': this.selectElementNode(selectedItem);
                break;
            case 'DYNAMIC_ELEMENT': this.selectElementNode(selectedItem);
                break;
            default: break;
        }

        this._validateAction(selectedItem.storedItem);
    }

    selectGeneralNode(item) {
        this.selectedFieldInitialized = false;
        let typePrefix = '';

        if (item.storedItem.Type == 'STANDARD_GENERAL') {
            typePrefix = 'GeneralAction_';
        } else {
            typePrefix = 'ActionSubType_';
        }

        $('#' + this.fieldsDefinitionItem)[0].innerHTML = this.getGeneralActionDefinitionTemplate(item);
        $('#' + this.actionTitle)[0].innerHTML = item.storedItem.SubType != null ? this.getResource(typePrefix + item.storedItem.SubType) : 'Nedefinit';
        $('#' + this.actionText).val(item.storedItem.Text);
        $('#' + this.actionTooltip).val(item.storedItem.Title);

        let classData = [];

        if (this.type == 'list') {
            classData = [{
                name: "Primary (grid-primary)",
                value: "grid-primary"
            }, {
                name: "Secondary (grid-secondary)",
                value: "grid-secondary"
            }, {
                name: "Danger (grid-danger)",
                value: "grid-danger"
            }, {
                name: "Info (grid-info)",
                value: "grid-info"
            }, {
                name: "Warning (grid-warning)",
                value: "grid-warning"
            }, {
                name: "Success (grid-success)",
                value: "grid-success"
            }];
        } else {
            classData = [{
                name: "Primary (ml-2 btn-primary)",
                value: "ml-2 btn-primary"
            }, {
                name: "Secondary (ml-2 btn-secondary)",
                value: "ml-2 btn-secondary"
            }, {
                name: "Danger (ml-2 btn-danger)",
                value: "ml-2 btn-danger"
            }, {
                name: "Info (ml-2 btn-info)",
                value: "ml-2 btn-info"
            }, {
                name: "Warning (ml-2 btn-warning)",
                value: "ml-2 btn-warning"
            }, {
                name: "Success (ml-2 btn-success)",
                value: "ml-2 btn-success"
            }];
        }

        if ($('#' + this.actionModalHeight).length > 0 && $('#' + this.actionModalWidth).length > 0) {
            $('#' + this.actionModalHeight).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });

            $('#' + this.actionModalWidth).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });

            let isAlwaysModal = false;

            if (item.storedItem.UiContent != null && item.storedItem.UiContent.trim() != '') {
                let uiContent = JSON.parse(item.storedItem.UiContent);

                if (uiContent.modalHeight != null) {
                    $('#' + this.actionModalHeight).val(uiContent.modalHeight);
                }

                if (uiContent.modalWidth != null) {
                    $('#' + this.actionModalWidth).val(uiContent.modalWidth);
                }

                if (uiContent.isAlwaysModal != null) {
                    isAlwaysModal = uiContent.isAlwaysModal;
                }
            }

            $('#' + this.actionAlwaysModal).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: isAlwaysModal,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });

            let showInQuickLegend = false;

            if (item.storedItem.Content != null && item.storedItem.Content.trim() != '') {
                let content = JSON.parse(item.storedItem.Content);

                if (content.showInQuickLegend != null) {
                    showInQuickLegend = content.showInQuickLegend;
                }
            }

            $('#' + this.actionShowInQuickLegend).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: showInQuickLegend,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });
        }

        if (item.subType == "Timeline") {
            this._initTimelineConfig(item);
        }

        if (item.subType == "FollowUserPosition") {
            this._initFollowUserPositionConfig(item);
        }

        $('#' + this.actionPlatforms).kendoMultiSelect({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetPlatforms?parentType=' + this.objectType + '&type=' + item.storedItem.Type + '&subtype=' + item.storedItem.SubType;
                        }
                    }
                }
            },
            change: (e) => {
                this._platform_onChange(e);
                this.saveDetails();
                loadPreview();
            },
            dataBound: (e) => {
                this._setPlatform(e.sender, item.storedItem.Platforms);
                if (e.sender.dataSource.data().length == 1 && (e.sender.value() == null || (e.sender.value().trim != null && e.sender.value().trim() == ''))) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if ($('#' + this.actionPlatforms).data('kendoMultiSelect') != null) {
            this._setPlatform($('#' + this.actionPlatforms).data('kendoMultiSelect'), item.storedItem.Platforms);
        }
        $('#' + this.actionClassName).kendoComboBox({
            dataTextField: 'value',
            dataValueField: 'value',
            dataSource: {
                data: classData
            },
            template: (e) => {
                return '<button class="btn ' + e.value + '" style="margin-right:0.5rem;"></button>' + e.name;
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionClassName).data('kendoComboBox').text(item.storedItem.ClassName);

        $('#' + this.actionText).on('focusout', () => {
            this.saveDetails();
            loadPreview();

            if (item.storedItem.Type == 'DYNAMIC_GENERAL' || item.storedItem.Type == 'GROUP' || item.storedItem.Type == 'SEPARATOR') {
                this.selectedField.set('displayText', this.selectedField.storedItem.Text + ' (' + this.getResource('ActionSubType_' + this.selectedField.storedItem.SubType) + ')');
            }
        });

        $('#' + this.actionTooltip).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionPermissionType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetPermReqType?subtype=' + item.storedItem.SubType + '&type=' + item.storedItem.Type + '&parentType=' + this.objectType;
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            },
            dataBound: (e) => {
                if (e.sender.dataSource.data().length == 1 && (e.sender.value() == null || (e.sender.value().trim != null && e.sender.value().trim() == ''))) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if (item.storedItem.PermReqType != null && $('#' + this.actionPermissionType).data('kendoComboBox') != null) {
            $('#' + this.actionPermissionType).data('kendoComboBox').value(item.storedItem.PermReqType);
        }

        $('#' + this.actionIcon).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            template: '<i class="#: Name # m-1"></i><span class="k-state-default ml-2">#: Name #</span>',
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (!this.selectedFieldInitialized && $('#' + this.actionIcon).data('kendoComboBox').text() == '' && this.selectedField.storedItem.Icon != null && this.selectedField.storedItem.Icon != '') {
                                return rootURL + 'General/GetIcons?text=' + this.selectedField.storedItem.Icon;
                            } else {
                                return rootURL + 'General/GetIcons?text=' + $('#' + this.actionIcon).data('kendoComboBox').text();
                            }
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionIcon).data('kendoComboBox') != null) {
            $('#' + this.actionIcon).data('kendoComboBox').value(item.storedItem.Icon);
        }

        $('#' + this.actionMobileIcon).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'code',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            template: '<span class="material-symbols-rounded">#: value #</span><span class="k-state-default ml-2">#: name #</span>',
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (!this.selectedFieldInitialized && $('#' + this.actionMobileIcon).data('kendoComboBox').text() == '' && this.selectedField.storedItem.IconMobile != null && this.selectedField.storedItem.IconMobile != '') {
                                return rootURL + 'General/GetMaterialIcons?code=' + this.selectedField.storedItem.IconMobile;
                            } else {
                                return rootURL + 'General/GetMaterialIcons?text=' + $('#' + this.actionMobileIcon).data('kendoComboBox').text();
                            }
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionMobileIcon).data('kendoComboBox') != null) {
            $('#' + this.actionMobileIcon).data('kendoComboBox').value(item.storedItem.IconMobile);
        }

        $('#' + this.actionForm).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityForm/GetForm';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionForm).data('kendoComboBox') != null) {
            $('#' + this.actionForm).data('kendoComboBox').value(item.storedItem.IdFormTarget);
        }

        $('#' + this.actionType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetDynamicGeneralType?parentType=' + this.objectType;
                        }
                    }
                }
            },
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.storedItem.SubType = value;
                this.selectedField.storedItem.Content = null;
                this.selectedField.set('displayText', this.selectedField.storedItem.Text + ' (' + this.getResource('ActionSubType_' + value) + ')');
                $('#' + this.actionTitle)[0].innerHTML = this.getResource('ActionSubType_' + value);
                this.saveDetails();
                this.handleDynamicContent();
                loadPreview();
            },
            dataBound: (e) => {
                if (this.selectedField.storedItem.SubType != null && this.selectedField.storedItem.SubType != '') {
                    $('#' + this.actionType).data('kendoComboBox').value(this.selectedField.storedItem.SubType);
                    this.handleDynamicContent();
                    this._validateAction(this.selectedField.storedItem);
                }
            }
        });

        this._addLayoutTemplateEvents();

        this.selectedFieldInitialized = true;
        addHelp();
    }


    _initFollowUserPositionConfig(item) {
        $('#' + this.actionFollowZoom).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionFollowDisable).kendoSwitch({
            messages: {
                checked: this.getResource('SWITCH_ON'),
                unchecked: this.getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionFollowEnabled).kendoSwitch({
            messages: {
                checked: this.getResource('SWITCH_ON'),
                unchecked: this.getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if (item.storedItem.Content != null && item.storedItem.Content.trim().length > 0) {
            let followUserPositionConfig = JSON.parse(item.storedItem.Content);

            $('#' + this.actionFollowZoom).val(followUserPositionConfig.zoom);
            $('#' + this.actionFollowDisable).data('kendoSwitch').check(followUserPositionConfig.autoDisableOnMapPan);
            $('#' + this.actionFollowEnabled).data('kendoSwitch').check(followUserPositionConfig.initiallyEnabled);
        }
    }

    _initPrintingConfig(item) {
        $('#' + this.actionPrintingPageType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                Id: 'A0',
                Name: 'A0'
            }, {
                Id: 'A1',
                Name: 'A1'
            }, {
                Id: 'A2',
                Name: 'A2'
            }, {
                Id: 'A3',
                Name: 'A3'
            }, {
                Id: 'A4',
                Name: 'A4'
            }],
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionPrintingPageOrientation).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: [{
                Id: 'Landscape',
                Name: 'Landscape'
            }, {
                Id: 'Portrait',
                Name: 'Portrait'
            }],
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        this.htmlPrintingTemplate = ace.edit(this.actionPrintingTemplate, {
            mode: "ace/mode/html",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        if (item.storedItem.Content != null && item.storedItem.Content.trim().length > 0) {
            let printingConfig = JSON.parse(item.storedItem.Content);

            $('#' + this.actionPrintingPageType).data('kendoComboBox').value(printingConfig.pageType);
            $('#' + this.actionPrintingPageOrientation).data('kendoComboBox').value(printingConfig.pageOrientation);

            this.htmlPrintingTemplate.setValue(printingConfig.template);
        } else {
            this.htmlPrintingTemplate.setValue('');
        }
    }

    _initAnalysisConfig(item) {
        $('#' + this.actionAnalysisOperatorType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetSpatialOperatorTypes';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionAnalysisSelectorStyle).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Style/GetStyles';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionAnalysisResultStyle).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Style/GetStyles';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionAnalysisQuickSearch).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getMapSearches(),
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionAnalysisBuffer).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionAnalysisResultType).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'value',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                data: [
                    {
                        name: this.getResource('ANALYSIS_list'),
                        value: 'list'
                    }, {
                        name: this.getResource('ANALYSIS_report'),
                        value: 'report'
                    }
                ]
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionAnalysisLayers).kendoGrid({
            noRecords: true,
            messages: {
                noRecords: this.getResource('Grid_NoRecord')
            },
            sortable: true,
            pageable: {
                refresh: true,
                pageSizes: true,
                buttonCount: 5
            },
            toolbar: [{
                name: 'addActionLayer',
                text: this.getResource('Add'),
                iconClass: 'fal fa-plus-square',
                attr: 'href="javascript:void(0)" class="grid-primary"'
            },
                "search"],
            columns: [{
                field: 'IdMapLayer',
                title: this.getResource('LayerName'),
                width: '6rem',
                attributes: {
                    minWidth: '6rem',
                    canBeHidden: 'false',
                    style: 'text-align: center'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' },
                template: (e) => {
                    return '<div id="cbox-layer-' + e.Idx + '" class="form-control"></div>';
                }
            },
            {
                field: 'IdListTemplate',
                title: this.getResource('LayerResultTemplate'),
                width: '4rem',
                attributes: {
                    minWidth: '4rem',
                    canBeHidden: 'false',
                    style: 'text-align: center'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' },
                template: (e) => {
                    if (e.IdListTemplate != null && e.IdListTemplate != 0) {
                        return '<button id="list-tmpl-' + e.Idx + '" class="btn grid-primary">' + this.getResource('EditTemplate') + '</button>' +
                            '<button id="list-tmpl-clear-' + e.Idx + '" class="btn grid-danger ml-1" title="' + this.getResource('ClearTemplate') + '"><i class="fal fa-brush"></i></button>';
                    }
                    else {
                        //return '<button id="list-tmpl-' + e.Idx + '" class="btn grid-secondary">' + this.getResource('AddTemplate') + '</button>' +
                        //    '<button id="list-tmpl-search-' + e.Idx + '" class="btn grid-secondary ml-1" title="' + this.getResource('SelectTemplate') + '"><i class="fal fa-search"></i></button>';
                        return '<button id="list-tmpl-search-' + e.Idx + '" class="btn grid-secondary">' + this.getResource('SelectTemplate') + '</button>' +
                            '<button id="list-tmpl-' + e.Idx + '" class="btn grid-secondary ml-1" title="' + this.getResource('AddTemplate') + '"><i class="fal fa-plus"></i></button>';
                    }
                }
            },
            {
                field: 'IdReportTemplate',
                title: this.getResource('LayerReportTemplate'),
                width: '4rem',
                attributes: {
                    minWidth: '4rem',
                    canBeHidden: 'false',
                    style: 'text-align: center'
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' },
                template: (e) => {
                    if (e.IdReportTemplate != null && e.IdReportTemplate != 0) {
                        return '<button id="report-tmpl-' + e.Idx + '" class="btn grid-primary">' + this.getResource('EditTemplate') + '</button>' +
                            '<button id="report-tmpl-clear-' + e.Idx + '" class="btn grid-danger ml-1" title="' + this.getResource('ClearTemplate') + '"><i class="fal fa-brush"></i></button>';
                    }
                    else {
                        return '<button id="report-tmpl-' + e.Idx + '" class="btn grid-secondary">' + this.getResource('AddTemplate') + '</button>' +
                            '<button id="report-tmpl-search-' + e.Idx + '" class="btn grid-secondary ml-1" title="' + this.getResource('SelectTemplate') + '"><i class="fal fa-search"></i></button>';
                    }
                }
            },
            {
                command: [
                    {
                        attr: 'title="' + this.getResource('Remove') + '" class="grid-danger" style="width:2rem;"',
                        name: 'RemoveActionLayer',
                        text: '',
                        iconClass: 'fal fa-times',
                        click: (e) => {
                            e.preventDefault();
                            let item = $('#' + this.actionAnalysisLayers).data('kendoGrid').dataItem($(e.currentTarget).closest("tr"));

                            var items = $('#' + this.actionAnalysisLayers).data('kendoGrid').dataSource.data();

                            var newItems = [];

                            for (var i = 0; i < items.length; i++) {
                                if (items[i].Idx != item.Idx) {
                                    newItems.push(items[i]);
                                }
                            }

                            let dataSource = new kendo.data.DataSource({
                                data: newItems,
                                pageSize: 10,
                                page: 1
                            });

                            $('#' + this.actionAnalysisLayers).data('kendoGrid').setDataSource(dataSource);
                        }
                    }
                ],
                title: '',
                width: '2.5rem',
                attributes: {
                    minWidth: '2.5rem',
                    canBeHidden: 'false',
                    style: 'text-align: center; text-overflow: clip; '
                },
                headerAttributes: { style: 'text-align: center; justify-content: center' }
            }],
            dataBound: (e) => {
                e.sender.dataItems().forEach(item => {
                    $('#cbox-layer-' + item.Idx).kendoComboBox({
                        dataTextField: 'Name',
                        dataValueField: 'Id',
                        filter: 'contains',
                        suggest: true,
                        ignoreCase: true,
                        dataSource: {
                            serverFiltering: false,
                            transport: {
                                read: {
                                    dataType: 'json',
                                    url: () => {
                                        return rootURL + 'Map/GetMapEntityLayers?idMap=' + this.objectId;
                                    }
                                }
                            }
                        },
                        change: (e) => {
                            item.IdMapLayer = e.sender.value();
                            
                            this.saveDetails();
                            loadPreview();
                        }
                    });

                    if (item.IdMapLayer != null && item.IdMapLayer != 0) {
                        $('#cbox-layer-' + item.Idx).data('kendoComboBox').value(item.IdMapLayer);
                    }

                    //if ((item.IdListTemplate != null && item.IdListTemplate != 0) || (item.IdReportTemplate != null && item.IdReportTemplate != 0)) {
                    //    $('#cbox-layer-' + item.Idx).data('kendoComboBox').enable(false);
                    //}

                    $('#list-tmpl-' + item.Idx).on('click', (e) => {
                        var url = rootUrl + "XpTemplate/XpTemplateForm?";
                        if (item.IdListTemplate == null || item.IdListTemplate == 0) {
                            url += "idMapLayer=" + item.IdMapLayer;
                        }
                        else {
                            url += "id=" + item.IdListTemplate;
                        }
                        url += "&context=modal";

                        showModalWindowExt(url, this.getResource("LayerResultTemplate"), "fal fa-credit-card-front", "80%", "80%");
                        $event.clear("xpTemplate_AfterSave");
                        this._editTemplateInfo = {};
                        this._editTemplateInfo.item = item;
                        this._editTemplateInfo.type = 'ListTemplate';
                        $event.register("xpTemplate_AfterSave", this._afterTemplateSave(), this);
                    });
                    $('#list-tmpl-clear-' + item.Idx).on('click', (e) => {
                        item.IdListTemplate = null;                        
                        var grd = $('#' + this.actionAnalysisLayers).data('kendoGrid');
                        grd.dataSource.read();
                    });
                    $('#list-tmpl-search-' + item.Idx).on('click', (e) => {
                        this._editTemplateInfo = {};
                        this._editTemplateInfo.item = item;
                        this._editTemplateInfo.type = 'ListTemplate';
                        this._initAnalysisSearchTemplateWindow();
                    });

                    $('#report-tmpl-' + item.Idx).on('click', (e) => {
                        var url = rootUrl + "XpTemplate/XpTemplateForm?";
                        if (item.IdReportTemplate == null || item.IdReportTemplate == 0) {
                            url += "idMapLayer=" + item.IdMapLayer;
                        }
                        else {
                            url += "id=" + item.IdReportTemplate;
                        }
                        url += "&context=modal";

                        showModalWindowExt(url, this.getResource("LayerResultTemplate"), "fal fa-credit-card-front", "80%", "80%");
                        $event.clear("xpTemplate_AfterSave");
                        this._editTemplateInfo = {};
                        this._editTemplateInfo.item = item;
                        this._editTemplateInfo.type = 'ReportTemplate';
                        $event.register("xpTemplate_AfterSave", this._afterTemplateSave(), this);
                    });
                    $('#report-tmpl-clear-' + item.Idx).on('click', (e) => {
                        item.IdReportTemplate = null;
                        var grd = $('#' + this.actionAnalysisLayers).data('kendoGrid');
                        grd.dataSource.read();
                    });
                    $('#report-tmpl-search-' + item.Idx).on('click', (e) => {
                        this._editTemplateInfo = {};
                        this._editTemplateInfo.item = item;
                        this._editTemplateInfo.type = 'ReportTemplate';
                        this._initAnalysisSearchTemplateWindow();
                    });

                });
            }
        });

        let items = [];
        let idx = 0;

        if (this.selectedField.storedItem.ActionLayers != null && this.selectedField.storedItem.ActionLayers.length > 0) {
            this.selectedField.storedItem.ActionLayers.forEach(actionLayer => {
                actionLayer.Idx = ++idx;
                items.push(actionLayer);
            });
        }

        let dataSource = new kendo.data.DataSource({
            data: items,
            pageSize: 10,
            page: 1
        });

        dataSource.read();

        $('#' + this.actionAnalysisLayers).data('kendoGrid').setDataSource(dataSource);

        $('#' + this.actionAnalysisLayers + ' .k-grid-addActionLayer').on('click', () => {
            var items = $('#' + this.actionAnalysisLayers).data('kendoGrid').dataSource.data();

            let lastIdx = 0;

            if (items.length > 0) {
                lastIdx = items[items.length - 1].Idx;
            }

            let newItem = {
                Id: 0,
                IdMapLayer: 0,
                Idx: ++lastIdx
            }

            items.push(newItem);

            let dataSource = new kendo.data.DataSource({
                data: items,
                pageSize: 10,
                page: 1
            });

            dataSource.read();

            $('#' + this.actionAnalysisLayers).data('kendoGrid').setDataSource(dataSource);
        });

        this.htmlMainEditorHeader = ace.edit(this.actionAnalysisMainTemplateHeader, {
            mode: "ace/mode/html",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        this.htmlMainEditorFooter = ace.edit(this.actionAnalysisMainTemplateFooter, {
            mode: "ace/mode/html",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        $('#' + this.actionAnalysisMainTemplateHeader).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionAnalysisMainTemplateFooter).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        if (item.storedItem.Content != null && item.storedItem.Content.trim().length > 0) {
            let analysisConfig = JSON.parse(item.storedItem.Content);

            $('#' + this.actionAnalysisBuffer).val(analysisConfig.buffer);
            $('#' + this.actionAnalysisOperatorType).data('kendoComboBox').value(analysisConfig.operatorType);
            $('#' + this.actionAnalysisSelectorStyle).data('kendoComboBox').value(analysisConfig.selectorStyle);
            $('#' + this.actionAnalysisResultStyle).data('kendoComboBox').value(analysisConfig.resultStyle);
            $('#' + this.actionAnalysisQuickSearch).data('kendoComboBox').value(analysisConfig.quickSearch);
            $('#' + this.actionAnalysisResultType).data('kendoComboBox').value(analysisConfig.resultType);

            this.htmlMainEditorHeader.setValue(analysisConfig.header);
            this.htmlMainEditorFooter.setValue(analysisConfig.footer);
        }
    }

    _getMapSearches() {
        let mapSearches = $('#ctrlMapSearches').data('kendoGrid').dataSource.data();
        let result = [];

        mapSearches.forEach((mapSearch) => {
            if (mapSearch.Id != null && mapSearch.Id != 0) {
                result.push({
                    Id: mapSearch.Id,
                    Name: mapSearch.Name
                });
            }
        });

        return result;
    }
    _afterTemplateSave() {
        var handler = (eventName, event, sender) => {
            var layerIdx = this._editTemplateInfo.item.Idx;
            let item = this._editTemplateInfo.item;
            var data = event.data;
            if (this._editTemplateInfo.type == 'ListTemplate') {
                if (item.IdListTemplate != data.Id) {
                    item.IdListTemplate = data.Id;
                    var grd = $('#' + this.actionAnalysisLayers).data('kendoGrid');
                    grd.dataSource.read();
                }                
            } else {
                if (item.IdReportTemplate != data.Id) {
                    item.IdReportTemplate = data.Id;
                    var grd = $('#' + this.actionAnalysisLayers).data('kendoGrid');
                    grd.dataSource.read();
                }  
            }
            //if ((item.IdListTemplate != null && item.IdListTemplate != 0) || (item.IdReportTemplate != null && item.IdReportTemplate != 0)) {
            //    $('#cbox-layer-' + item.Idx).data('kendoComboBox').enable(false);
            //}
            //else {
            //    $('#cbox-layer-' + item.Idx).data('kendoComboBox').enable(true);
            //}
            this.saveDetails();
            loadPreview();     
        };

        return handler;
    }   
    
    _initAnalysisSearchTemplateWindow() {
        $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr" id="` + this.layoutTemplateInner + `"></div>`;

        let htmlWindowOptions = {
            draggable: false,
            resizable: true,
            width: "50%",
            height: "fit-content",
            title: this.getResource("SearchTemplate"),
            modal: true,
            close: () => { this._closeHtmlTemplateWindow(); }
        };

        $('#' + this.layoutTemplateInner).kendoWindow(htmlWindowOptions);
        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }        
        let template = ``;
        template += `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <label class="form-label">` + this.getResource('Template') + `</label>
                                <div class="form-control" id="` + this.actionAnalysisTemplateSelect + `" style="width: 100%;">
                                </div>
                            </div>
                        </div>`;

        template += `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-0">
                            <button class="btn btn-secondary ml-auto mt-3" onclick="` + this.uniqueId + `._closeHtmlTemplateWindow()" title="` + this.getResource('Cancel') + `" type="button">` + this.getResource('Cancel') + `</button>
                            <button class="btn btn-primary ml-2 mt-3" onclick="` + this.uniqueId + `._saveAnalysisSearchTemplate()" title="` + this.getResource('Select') + `" type="button">` + this.getResource('Select') + `</button>
                        </div>`;

        $('#' + this.layoutTemplateInner)[0].innerHTML = template;

        //this._editTemplateInfo = {};
        var item = this._editTemplateInfo.item;
        //this._editTemplateInfo.type = 'ListTemplate'
        $('#' + this.actionAnalysisTemplateSelect).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'XpTemplate/GetEntityTemplates';
                        }
                    }
                }
            }
        });
        $('#' + this.layoutTemplateInner).data("kendoWindow").center();
    }
    _saveAnalysisSearchTemplate() {
        var cbo = $('#' + this.actionAnalysisTemplateSelect).data("kendoComboBox");
        if (cbo.value() == null) {
            alert(this.getResource('Select_EM'));
            return;
        }

        let item = this._editTemplateInfo.item;
        if (this._editTemplateInfo.type == 'ListTemplate') {
            if (item.IdListTemplate != cbo.value()) {
                item.IdListTemplate = cbo.value();  
                var grd = $('#' + this.actionAnalysisLayers).data('kendoGrid');
                grd.dataSource.read();
            }
        } else {
            if (item.IdReportTemplate != cbo.value()) {
                item.IdReportTemplate = cbo.value();
                var grd = $('#' + this.actionAnalysisLayers).data('kendoGrid');
                grd.dataSource.read();
            }
        }
        this._closeHtmlTemplateWindow();
    }
        
    _setPlatform(ctl, value) {
        var val = null;
        var data = ctl.dataSource.data();

        if (value != null && value.length>0) {
            val = value.split(",");
            var hasAvail = false;
            var foundNotSelected=false;
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id == "ALL_AVAIL") {
                    hasAvail = true;
                }
                else if (value.indexOf(data[i].Id)<0){
                    foundNotSelected = true;
                }
            }
            if (hasAvail && !foundNotSelected) {
                val = [];
                val.push("ALL_AVAIL");
            }
        }
        else {
            val = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id == "ALL") {
                    val.push("ALL");
                    break;
                }
                else if (data[i].Id == "ALL_AVAIL") {
                    val.push("ALL_AVAIL");
                    break;
                }
            }
        }
        ctl.value(val);
    }
    _getPlatform(ctl) {        
        if (ctl == null) {
            return null;
        }
        var data = ctl.dataSource.data();
        var hasAvail = false;
        for (var i = 0; i < data.length; i++) {
            if (data[i].Id == "ALL_AVAIL") {
                hasAvail = true;
                break;
            }
        }

        var val = ctl.value();
        if (val == null || val.length == 0) {
            if (hasAvail) {
                val = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].Id != "ALL_AVAIL") {
                        val.push[data[i].Id];
                    }
                }
            }
            else {
                return null;
            }            
        }
        if (val == "ALL") {
            return null;
        }
        else if (val == "ALL_AVAIL") {
            val = [];
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id != "ALL_AVAIL") {
                    val.push(data[i].Id);
                }
            }
        }
        return val.join(",");
    }
    _platform_onChange(e) {
        var ctl = e.sender;
        var val = ctl.value();
        var all = false;
        if (val != null && (val.length == 0 || val[val.length - 1] == "ALL" || val[val.length - 1] == "ALL_AVAIL")) {
            all = true;
        }
        if (val == null) {
            all = true;
        }
        if (all) {
            var data = ctl.dataSource.data();
            for (var i = 0; i < data.length; i++) {
                if (data[i].Id == "ALL") {
                    ctl.value(["ALL"]);
                    break;
                }
                else if (data[i].Id == "ALL_AVAIL") {
                    ctl.value(["ALL_AVAIL"]);
                    break;
                }
            }
        }
        else {
            //daca exista All trebuie sa il scot. probabil nu este ultimul (caz tratat mai sus)
            var newVal = [];
            var found = false;
            for (var i = 0; i < val.length; i++) {
                if (val[i] == "ALL") {
                    found = true;
                }
                else if (val[i] == "ALL_AVAIL") {
                    found = true;
                }
                else {
                    newVal.push(val[i]);
                }
            }
            if (found) {
                ctl.value(newVal);
            }
        }
    }

    _initTimelineConfig(item) {
        $('#' + this.actionTimelineType).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'value',
            dataSource: {
                data: [{
                    name: this.getResource('TIMELINE_continuous'),
                    value: 'continuous'
                }, {
                    name: this.getResource('TIMELINE_discrete'),
                    value: 'discrete'
                }]
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionTimelineUnit).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'value',
            dataSource: {
                data: [{
                    name: this.getResource('TIMELINE_y'),
                    value: 'y'
                }, {
                    name: this.getResource('TIMELINE_M'),
                    value: 'M'
                }, {
                    name: this.getResource('TIMELINE_d'),
                    value: 'd'
                }, {
                    name: this.getResource('TIMELINE_h'),
                    value: 'h'
                }, {
                    name: this.getResource('TIMELINE_min'),
                    value: 'm'
                }, {
                    name: this.getResource('TIMELINE_s'),
                    value: 's'
                }]
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionTimelineIntervalType).kendoSwitch({
            messages: {
                checked: this.getResource('SWITCH_ON'),
                unchecked: this.getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                if (e.checked) {
                    $('.action-timeline-def-interval').show();
                    $('.action-timeline-cus-interval').hide();
                } else {
                    $('.action-timeline-def-interval').hide();
                    $('.action-timeline-cus-interval').show();
                }
                this.saveDetails();
                loadPreview();
            }
        });

        $("#" + this.actionTimelineStart).kendoDateTimePicker({});
        $("#" + this.actionTimelineEnd).kendoDateTimePicker({});

        $('#' + this.actionTimelineIntervalPeriodType).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'value',
            dataSource: {
                data: [{
                    name: this.getResource('TIMELINE_last_year'),
                    value: 'last_year'
                }, {
                    name: this.getResource('TIMELINE_last_month'),
                    value: 'last_month'
                }, {
                    name: this.getResource('TIMELINE_last_day'),
                    value: 'last_day'
                }, {
                    name: this.getResource('TIMELINE_last_hour'),
                    value: 'last_hour'
                }]
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionTimelineIntervalPeriodLength).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionTimelineFormat).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionTimelineLoop).kendoSwitch({
            messages: {
                checked: this.getResource('SWITCH_ON'),
                unchecked: this.getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionTimelineSelectorType).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'value',
            dataSource: {
                data: [{
                    name: this.getResource('TIMELINE_point'),
                    value: 'point'
                }, {
                    name: this.getResource('TIMELINE_interval'),
                    value: 'interval'
                }]
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionTimelineBackground).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionTimelineThumb).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionTimelineChannel).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionTimelineSpeed).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        if (item.storedItem.Content != null && item.storedItem.Content.trim().length > 0) {
            let timelineConfig = JSON.parse(item.storedItem.Content);
            $('#' + this.actionTimelineType).data('kendoComboBox').value(timelineConfig.type);
            $('#' + this.actionTimelineUnit).data('kendoComboBox').value(timelineConfig.unit);
            $("#" + this.actionTimelineStart).data('kendoDateTimePicker').value(timelineConfig.start);
            $("#" + this.actionTimelineEnd).data('kendoDateTimePicker').value(timelineConfig.end);
            $('#' + this.actionTimelineFormat).val(timelineConfig.format);
            $('#' + this.actionTimelineLoop).data('kendoSwitch').check(timelineConfig.loop);

            $('#' + this.actionTimelineIntervalPeriodType).data('kendoComboBox').value(timelineConfig.periodType);
            $('#' + this.actionTimelineIntervalPeriodLength).val(timelineConfig.periodLength);

            if (timelineConfig.intervalType == null) {
                timelineConfig.intervalType = true;
            }

            if (timelineConfig.intervalType) {
                $('.action-timeline-def-interval').show();
                $('.action-timeline-cus-interval').hide();
            } else {
                $('.action-timeline-def-interval').hide();
                $('.action-timeline-cus-interval').show();
            }

            $('#' + this.actionTimelineIntervalType).data('kendoSwitch').check(timelineConfig.intervalType);
            $('#' + this.actionTimelineSelectorType).data('kendoComboBox').value(timelineConfig.selectorType);
            $('#' + this.actionTimelineBackground).val(timelineConfig.background);
            $('#' + this.actionTimelineThumb).val(timelineConfig.thumb);
            $('#' + this.actionTimelineChannel).val(timelineConfig.channel);
            $('#' + this.actionTimelineSpeed).val(timelineConfig.speed);
        }
    }

    _addLayoutTemplateEvents() {
        $('#' + this.actionStyle).on('click', () => {
            $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr" id="` + this.layoutTemplateInner + `"></div>`;

            let htmlWindowOptions = {
                draggable: false,
                resizable: true,
                width: "50%",
                height: "fit-content",
                title: this.getResource('Style'),
                modal: true,
                close: () => { this._closeHtmlTemplateWindow(); }
            };

            $('#' + this.layoutTemplateInner).kendoWindow(htmlWindowOptions);
            if ($('body')[0].classList.contains('mod-skin-dark')) {
                $('.k-window').addClass('mod-skin-dark');
            }
            this._initStyleLayoutTemplate();
            $('#' + this.layoutTemplateInner).data("kendoWindow").center();
        });

        $('#' + this.actionHtmlAttributes).on('click', () => {
            $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr" id="` + this.layoutTemplateInner + `"></div>`;

            let htmlWindowOptions = {
                draggable: false,
                resizable: true,
                width: "50%",
                height: "fit-content",
                title: this.getResource('HtmlAttributes'),
                modal: true,
                close: () => { this._closeHtmlTemplateWindow(); }
            };

            $('#' + this.layoutTemplateInner).kendoWindow(htmlWindowOptions);
            if ($('body')[0].classList.contains('mod-skin-dark')) {
                $('.k-window').addClass('mod-skin-dark');
            }
            this._initHtmlAttributesLayoutTemplate();
            $('#' + this.layoutTemplateInner).data("kendoWindow").center();
        });

        $('#' + this.actionNewFormMappings).on('click', () => {
            $('#' + this.layoutTemplateWrapper)[0].innerHTML = `<div class="pr" id="` + this.layoutTemplateInner + `"></div>`;

            let htmlWindowOptions = {
                draggable: false,
                resizable: true,
                width: "50%",
                height: "fit-content",
                title: this.getResource('NewFormMappings'),
                modal: true,
                close: () => { this._closeHtmlTemplateWindow(); }
            };

            $('#' + this.layoutTemplateInner).kendoWindow(htmlWindowOptions);
            if ($('body')[0].classList.contains('mod-skin-dark')) {
                $('.k-window').addClass('mod-skin-dark');
            }
            this._initNewFormMappingsLayoutTemplate();
            $('#' + this.layoutTemplateInner).data("kendoWindow").center();
        });
    }

    _getActionTargetColumns() {
        let fields = [];
        if (this.type == 'mapLayer') {
            if (this.uiFieldsControl == null) {
                this.uiFieldsControl = {
                    actionSubFormIdPkVal: 'IdFieldTarget',
                    actionSubFormIdForm: 'IdFormFieldTarget'
                };
            }
            let getFieldsUrl = rootUrl + 'Entity/GetFieldsByMapLayerId?idMapLayer=' + this.objectId;

            $.ajax({
                type: "GET",
                url: getFieldsUrl,
                async: false,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    result.forEach(row => { row.Label = row.FieldName });
                    fields = result;
                },
                error: (e) => {
                    toastr.error(this.getResource('GetFieldError'));
                }
            });
        } else if (this.uiFieldsControl == null) {
            return [];
        } else {
            fields = this.uiFieldsControl.getFields();
        }

        let availableFields = fields.filter(row => { return row.Id != null && row.Id != 0 && (row.DataType == 'STRING' || row.DataType == 'INTEGER' || (row.EntityField != null && (row.EntityField.DataType == 'STRING' || row.EntityField.DataType == 'INTEGER'))) });
        return availableFields;
    }

    _closeHtmlTemplateWindow() {
        $('#' + this.layoutTemplateInner).data("kendoWindow").destroy();
    }

    _initStyleLayoutTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group" style="text-align: center;">
                                    <label class="form-label">` + this.getResource('StyleName') + `</label>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3" style="text-align: center;">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('StyleValue') + `</label>
                                </div>
                            </div>
                        </div>`;

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            template += `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group">
                                    <input type="text" id="style_name_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="text-align: center; line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                    <label class="form-label">:</label>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <input type="text" id="style_value_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                        </div>`;
        }

        template += `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-0">
                        <button class="btn btn-secondary ml-auto mt-3" onclick="` + this.uniqueId + `._closeHtmlTemplateWindow()" title="` + this.getResource('Cancel') + `" type="button">` + this.getResource('Cancel') + `</button>
                        <button class="btn btn-primary ml-2 mt-3" onclick="` + this.uniqueId + `._saveLayoutStyle()" title="` + this.getResource('Save') + `" type="button">` + this.getResource('Save') + `</button>
                    </div>`;

        $('#' + this.layoutTemplateInner)[0].innerHTML = template;

        if (this.selectedField.storedItem.Style != null && this.selectedField.storedItem.Style.trim() != '') {
            let styleTuples = this.selectedField.storedItem.Style.split(';');

            for (var i = 0; i < styleTuples.length; i++) {
                let styleValueTuples = styleTuples[i].split(':');
                $('#style_name_' + i).val(styleValueTuples[0]);
                $('#style_value_' + i).val(styleValueTuples[1]);
            }
        }
    }

    _initHtmlAttributesLayoutTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group" style="text-align: center;">
                                    <label class="form-label">` + this.getResource('HtmlAttributeName') + `</label>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3" style="text-align: center;">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('HtmlAttributeValue') + `</label>
                                </div>
                            </div>
                        </div>`;

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            template += `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group">
                                    <input type="text" id="attribute_name_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="text-align: center; line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                    <label class="form-label">=</label>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <input type="text" id="attribute_value_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                        </div>`;
        }

        template += `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-0">
                        <button class="btn btn-secondary ml-auto mt-3" onclick="` + this.uniqueId + `._closeHtmlTemplateWindow()" title="` + this.getResource('Cancel') + `" type="button">` + this.getResource('Cancel') + `</button>
                        <button class="btn btn-primary ml-2 mt-3" onclick="` + this.uniqueId + `._saveLayoutHtmlAttributes()" title="` + this.getResource('Save') + `" type="button">` + this.getResource('Save') + `</button>
                    </div>`;

        $('#' + this.layoutTemplateInner)[0].innerHTML = template;

        if (this.selectedField.storedItem.SubType == 'DEX_EX_RPT' && this.selectedField.storedItem.Content != null && this.selectedField.storedItem.Content.trim() != '') {
            let contentObject = JSON.parse(this.selectedField.storedItem.Content);
            let keys = Object.keys(contentObject);
            let counter = 0;

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    $('#attribute_name_' + counter).val(keys[i]);
                    $('#attribute_value_' + counter).val(contentObject[keys[i]]);
                    counter++;
                }
            }
        } else if (this.selectedField.storedItem.HtmlAttributes != null) {
            let keys = Object.keys(this.selectedField.storedItem.HtmlAttributes);
            let counter = 0;

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    $('#attribute_name_' + counter).val(keys[i]);
                    $('#attribute_value_' + counter).val(this.selectedField.storedItem.HtmlAttributes[keys[i]]);
                    counter++;
                }
            }
        }
    }

    _initNewFormMappingsLayoutTemplate() {
        let template = `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group" style="text-align: center;">
                                    <label class="form-label">` + this.getResource('ListField') + `</label>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3" style="text-align: center;">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('FormField') + `</label>
                                </div>
                            </div>
                        </div>`;

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            template += `<div class="form-row">
                            <div class="col-sm-5 mb-3">
                                <div class="form-group">
                                    <input type="text" id="attribute_name_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                            <div class="col-sm-1 mb-3">
                                <div class="form-group" style="text-align: center; line-height: 2rem; font-size: 1rem; font-weight: bold;">
                                    <label class="form-label">=</label>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <input type="text" id="attribute_value_` + i + `" class="form-control" autocomplete="off"/>
                                </div>
                            </div>
                        </div>`;
        }

        template += `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 mr-0">
                        <button class="btn btn-secondary ml-auto mt-3" onclick="` + this.uniqueId + `._closeHtmlTemplateWindow()" title="` + this.getResource('Cancel') + `" type="button">` + this.getResource('Cancel') + `</button>
                        <button class="btn btn-primary ml-2 mt-3" onclick="` + this.uniqueId + `._saveNewFormMappingsAttributes()" title="` + this.getResource('Save') + `" type="button">` + this.getResource('Save') + `</button>
                    </div>`;

        $('#' + this.layoutTemplateInner)[0].innerHTML = template;

        if (this.selectedField.storedItem.Content != null) {
            let item = JSON.parse(this.selectedField.storedItem.Content);
            let keys = Object.keys(item.prefilledFields);
            let counter = 0;

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    $('#attribute_name_' + counter).val(keys[i]);
                    $('#attribute_value_' + counter).val(item.prefilledFields[keys[i]]);
                    counter++;
                }
            }
        }
    }

    _saveLayoutStyle() {
        let result = '';

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            let style = $('#style_name_' + i).val();
            let value = $('#style_value_' + i).val();

            if (style != null && style.trim() != '' & value != null && value.trim() != '') {
                result += style + ':' + value + ';';
            }
        }

        this.selectedField.storedItem.Style = result;

        this._closeHtmlTemplateWindow();
        this.saveDetails();
        loadPreview();
    }

    _saveLayoutHtmlAttributes() {
        if (this.selectedField.storedItem.SubType == 'DEX_EX_RPT') {

            let result = {};

            for (let i = 0; i < this.maxLayoutAttribute; i++) {
                let attribute = $('#attribute_name_' + i).val();
                let value = $('#attribute_value_' + i).val();

                if (attribute != null && attribute.trim() != '' & value != null && value.trim() != '') {
                    result[attribute] = value;
                }
            }

            this.selectedField.storedItem.Content = JSON.stringify(result);

            this._closeHtmlTemplateWindow();
            this.saveDetails();
            loadPreview();
        } else {
            let result = {};

            for (let i = 0; i < this.maxLayoutAttribute; i++) {
                let attribute = $('#attribute_name_' + i).val();
                let value = $('#attribute_value_' + i).val();

                if (attribute != null && attribute.trim() != '' & value != null && value.trim() != '') {
                    result[attribute] = value;
                }
            }

            this.selectedField.storedItem.HtmlAttributes = result;

            this._closeHtmlTemplateWindow();
            this.saveDetails();
            loadPreview();
        }
    }

    _saveNewFormMappingsAttributes() {
        let result = {
            prefilledFields: {

            }
        };

        for (let i = 0; i < this.maxLayoutAttribute; i++) {
            let attribute = $('#attribute_name_' + i).val();
            let value = $('#attribute_value_' + i).val();

            if (attribute != null && attribute.trim() != '' & value != null && value.trim() != '') {
                result.prefilledFields[attribute] = value;
            }
        }

        this.selectedField.storedItem.Content = JSON.stringify(result);

        this._closeHtmlTemplateWindow();
        this.saveDetails();
        loadPreview();
    }

    selectElementNode(item) {
        this.selectedFieldInitialized = false;

        let typePrefix = '';

        if (item.storedItem.Type == 'STANDARD_ELEMENT') {
            typePrefix = 'ElementAction_';
        } else {
            typePrefix = 'ActionSubType_';
        }

        $('#' + this.fieldsDefinitionItem)[0].innerHTML = this.getElementActionDefinitionTemplate(item);
        $('#' + this.actionTitle)[0].innerHTML = item.storedItem.SubType != null ? this.getResource(typePrefix + item.storedItem.SubType) : 'Nedefinit';
        $('#' + this.actionText).val(item.storedItem.Text);
        $('#' + this.actionTooltip).val(item.storedItem.Title);

        let classData = [];

        if (this.type == 'list') {
            classData = [{
                name: "Primary (grid-primary)",
                value: "grid-primary"
            }, {
                name: "Secondary (grid-secondary)",
                value: "grid-secondary"
            }, {
                name: "Danger (grid-danger)",
                value: "grid-danger"
            }, {
                name: "Info (grid-info)",
                value: "grid-info"
            }, {
                name: "Warning (grid-warning)",
                value: "grid-warning"
            }, {
                name: "Success (grid-success)",
                value: "grid-success"
            }];
        } else {
            classData = [{
                name: "Primary (ml-2 btn-primary)",
                value: "ml-2 btn-primary"
            }, {
                name: "Secondary (ml-2 btn-secondary)",
                value: "ml-2 btn-secondary"
            }, {
                name: "Danger (ml-2 btn-danger)",
                value: "ml-2 btn-danger"
            }, {
                name: "Info (ml-2 btn-info)",
                value: "ml-2 btn-info"
            }, {
                name: "Warning (ml-2 btn-warning)",
                value: "ml-2 btn-warning"
            }, {
                name: "Success (ml-2 btn-success)",
                value: "ml-2 btn-success"
            }];
        }

        if ($('#' + this.actionModalHeight).length > 0 && $('#' + this.actionModalWidth).length > 0) {
            $('#' + this.actionModalHeight).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });

            $('#' + this.actionModalWidth).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });

            let isAlwaysModal = false;

            if (item.storedItem.UiContent != null && item.storedItem.UiContent.trim() != '') {
                let uiContent = JSON.parse(item.storedItem.UiContent);

                if (uiContent.modalHeight != null) {
                    $('#' + this.actionModalHeight).val(uiContent.modalHeight);
                }

                if (uiContent.modalWidth != null) {
                    $('#' + this.actionModalWidth).val(uiContent.modalWidth);
                }

                if (uiContent.isAlwaysModal != null) {
                    isAlwaysModal = uiContent.isAlwaysModal;
                }
            }

            $('#' + this.actionAlwaysModal).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: isAlwaysModal,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });

            let showInQuickLegend = false;

            if (item.storedItem.Content != null && item.storedItem.Content.trim() != '') {
                let content = JSON.parse(item.storedItem.Content);

                if (content.showInQuickLegend != null) {
                    showInQuickLegend = content.showInQuickLegend;
                }
            }

            $('#' + this.actionShowInQuickLegend).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: showInQuickLegend,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });
        }

        $('#' + this.actionPlatforms).kendoMultiSelect({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetPlatforms?parentType=' + this.objectType + '&type=' + item.storedItem.Type + '&subtype=' + item.storedItem.SubType;
                        }
                    }
                }
            },
            change: (e) => {
                this._platform_onChange(e);
                this.saveDetails();
                loadPreview();
            },
            dataBound: (e) => {
                this._setPlatform(e.sender, item.storedItem.Platforms);
                if (e.sender.dataSource.data().length == 1 && (e.sender.value() == null || (e.sender.value().trim != null && e.sender.value().trim() == ''))) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if ($('#' + this.actionPlatforms).data('kendoMultiSelect') != null) {
            this._setPlatform($('#' + this.actionPlatforms).data('kendoMultiSelect'), item.storedItem.Platforms);
        }

        $('#' + this.actionClassName).kendoComboBox({
            dataTextField: 'value',
            dataValueField: 'value',
            dataSource: {
                data: classData
            },
            template: (e) => {
                return '<button class="btn ' + e.value + '" style="margin-right:0.5rem;"></button>' + e.name;
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionClassName).data('kendoComboBox').text(item.storedItem.ClassName);

        $('#' + this.actionText).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionTooltip).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        $('#' + this.actionPermissionType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetPermReqType?subtype=' + item.storedItem.SubType + '&type=' + item.storedItem.Type + '&parentType=' + this.objectType;
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            },
            dataBound: (e) => {
                if (e.sender.value() == null || (e.sender.value() != null && e.sender.dataSource.data().filter(row => { return row.Id == e.sender.value() }).length == 0)) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if (item.storedItem.PermReqType != null && $('#' + this.actionPermissionType).data('kendoComboBox') != null) {
            $('#' + this.actionPermissionType).data('kendoComboBox').value(item.storedItem.PermReqType);
        }


        $('#' + this.actionMinSelection).kendoNumericTextBox({
            decimals: 0,
            min: 0,
            format: '0',
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionMinSelection).data('kendoNumericTextBox') != null) {

            if (item.storedItem.MinSel != null) {
                $('#' + this.actionMinSelection).data('kendoNumericTextBox').value(item.storedItem.MinSel);
            } else {
                $('#' + this.actionMinSelection).data('kendoNumericTextBox').value(1);
            }
        }

        $('#' + this.actionMaxSelection).kendoNumericTextBox({
            decimals: 0,
            min: 0,
            format: '0',
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionMaxSelection).data('kendoNumericTextBox') != null) {
            if (item.storedItem.MaxSel != null) {
                $('#' + this.actionMaxSelection).data('kendoNumericTextBox').value(item.storedItem.MaxSel);
            } else {
                $('#' + this.actionMaxSelection).data('kendoNumericTextBox').value(1);
            }
        }

        $('#' + this.actionIcon).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Name',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            template: '<i class="#: Name # m-1"></i><span class="k-state-default ml-2">#: Name #</span>',
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (!this.selectedFieldInitialized && $('#' + this.actionIcon).data('kendoComboBox').text() == '' && this.selectedField.storedItem.Icon != null && this.selectedField.storedItem.Icon != '') {
                                return rootURL + 'General/GetIcons?text=' + this.selectedField.storedItem.Icon;
                            } else {
                                return rootURL + 'General/GetIcons?text=' + $('#' + this.actionIcon).data('kendoComboBox').text();
                            }
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionIcon).data('kendoComboBox') != null) {
            $('#' + this.actionIcon).data('kendoComboBox').value(item.storedItem.Icon);
        }

        $('#' + this.actionMobileIcon).kendoComboBox({
            dataTextField: 'name',
            dataValueField: 'code',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            template: '<span class="material-symbols-rounded">#: value #</span><span class="k-state-default ml-2">#: name #</span>',
            dataSource: {
                serverFiltering: true,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            if (!this.selectedFieldInitialized && $('#' + this.actionMobileIcon).data('kendoComboBox').text() == '' && this.selectedField.storedItem.IconMobile != null && this.selectedField.storedItem.IconMobile != '') {
                                return rootURL + 'General/GetMaterialIcons?code=' + this.selectedField.storedItem.IconMobile;
                            } else {
                                return rootURL + 'General/GetMaterialIcons?text=' + $('#' + this.actionMobileIcon).data('kendoComboBox').text();
                            }
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionMobileIcon).data('kendoComboBox') != null) {
            $('#' + this.actionMobileIcon).data('kendoComboBox').value(item.storedItem.IconMobile);
        }

        $('#' + this.actionForm).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityForm/GetForm';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionForm).data('kendoComboBox') != null) {
            $('#' + this.actionForm).data('kendoComboBox').value(item.storedItem.IdFormTarget);
        }
        
        $('#' + this.actionGeomField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetGeomFields?parentType=' + this.objectType + "&parentId=" + this.objectId;
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionGeomField).data('kendoComboBox') != null) {
            $('#' + this.actionGeomField).data('kendoComboBox').value(item.storedItem.IdFieldTarget);
        }

        $('#' + this.actionType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetDynamicElementType?parentType=' + this.objectType;
                        }
                    }
                }
            },
            change: (e) => {
                let value = e.sender.value();
                this.selectedField.storedItem.SubType = value;
                this.selectedField.set('displayText', this.getResource('ActionSubType_' + value));
                $('#' + this.actionTitle)[0].innerHTML = this.getResource('ActionSubType_' + value);
                this.saveDetails();
                loadPreview();
                this.handleDynamicContent();
            },
            dataBound: (e) => {
                if (this.selectedField.storedItem.SubType != null && this.selectedField.storedItem.SubType != '') {
                    $('#' + this.actionType).data('kendoComboBox').value(this.selectedField.storedItem.SubType);
                    this.handleDynamicContent();
                    this._validateAction(this.selectedField.storedItem);
                }
            }
        });

        this._addLayoutTemplateEvents();

        this.selectedFieldInitialized = true;
    }

    handleDynamicContent() {
        $('#' + this.actionDynamicContent)[0].innerHTML = this.getDynamicActionTemplate(this.selectedField);

        if (this.selectedField.storedItem.SubType == 'DEX_EX_RPT') {
            $('#' + this.actionHtmlAttributes).attr('title', this.getResource('ReportParams'));
            $('#' + this.actionHtmlAttributes)[0].innerHTML = this.getResource('ReportParams');
        }

        if ($('#' + this.actionModalHeight).length > 0 && $('#' + this.actionModalWidth).length > 0) {
            $('#' + this.actionModalHeight).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });

            $('#' + this.actionModalWidth).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });

            let isAlwaysModal = false;

            if (this.selectedField.storedItem.UiContent != null && this.selectedField.storedItem.UiContent.trim() != '') {
                let uiContent = JSON.parse(this.selectedField.storedItem.UiContent);

                if (uiContent.modalHeight != null) {
                    $('#' + this.actionModalHeight).val(uiContent.modalHeight);
                }

                if (uiContent.modalWidth != null) {
                    $('#' + this.actionModalWidth).val(uiContent.modalWidth);
                }

                if (uiContent.isAlwaysModal != null) {
                    isAlwaysModal = uiContent.isAlwaysModal;
                }
            }

            $('#' + this.actionAlwaysModal).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: isAlwaysModal,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });

            let showInQuickLegend = false;

            if (this.selectedField.storedItem.Content != null && this.selectedField.storedItem.Content.trim() != '') {
                let content = JSON.parse(this.selectedField.storedItem.Content);

                if (content.showInQuickLegend != null) {
                    showInQuickLegend = content.showInQuickLegend;
                }
            }

            $('#' + this.actionShowInQuickLegend).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: showInQuickLegend,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });
        }

        $('#' + this.actionUrl).val(this.selectedField.storedItem.Url);

        $('#' + this.actionUrl).on('focusout', () => {
            this.saveDetails();
            loadPreview();
        });

        if ($('#' + this.actionJs).length > 0) {
            this.jsEditor = ace.edit(this.actionJs, {
                mode: "ace/mode/javascript",
                selectionStyle: "text",
                theme: "ace/theme/chrome"
            });

            this.jsEditor.setValue(this.selectedField.storedItem.Js);

            $('#' + this.actionJs).on('focusout', () => {
                this.saveDetails();
                loadPreview();
            });
        }

        $('#' + this.actionGeomField).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetGeomFields?parentType=' + this.objectType + "&parentId=" + this.objectId;
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionGeomField).data('kendoComboBox') != null) {
            $('#' + this.actionGeomField).data('kendoComboBox').value(this.selectedField.storedItem.IdFieldTarget);
        }

        $('#' + this.actionFormWfFormFields).kendoMultiSelect({
            dataTextField: this.type == 'form' ? 'Name' : this.type == 'list' ? 'FieldName' : 'Label',
            dataValueField: this.type == 'form' ? 'Name' : 'FieldName',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getActionTargetColumns(),
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if (this.type == 'application' && this.subType == 'app' && this.selectedField.storedItem.SubType != 'JS') {
            $('#' + this.actionLoadOnStart).kendoSwitch({
                messages: {
                    checked: this.getResource('SWITCH_ON'),
                    unchecked: this.getResource('SWITCH_OFF')
                },
                checked: false,
                change: (e) => {
                    this.saveDetails();
                    loadPreview();
                }
            });

            $('#' + this.actionLoadOnStart).data('kendoSwitch').check(this.selectedField.storedItem.LoadOnStart);
        }

        if ($('#' + this.actionFormWfFormFields).data('kendoMultiSelect') != null) {
            if (this.selectedField.storedItem.Content != null && this.selectedField.storedItem.Content != '')
                $('#' + this.actionFormWfFormFields).data('kendoMultiSelect').value(JSON.parse(this.selectedField.storedItem.Content));
        }

        $('#' + this.actionPlugin).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetPlugins?parentType=' + this.objectType + '&context=' + (this.selectedField.storedItem.Type.indexOf('GENERAL') >= 0 ? 'GENERAL' : 'ELEMENT');
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionPlugin).data('kendoComboBox') != null) {
            $('#' + this.actionPlugin).data('kendoComboBox').value(this.selectedField.storedItem.Content);
        }

        $('#' + this.actionDashboard).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Dashboard/GetAllDashboards';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionDashboard).data('kendoComboBox') != null) {
            $('#' + this.actionDashboard).data('kendoComboBox').value(this.selectedField.storedItem.IdDashboardTarget);
        }

        $('#' + this.actionReport).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'DevExRpt/GetAllDevExRpts';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if ($('#' + this.actionReport).data('kendoComboBox') != null) {
            $('#' + this.actionReport).data('kendoComboBox').value(this.selectedField.storedItem.IdDevExRptTarget);
        }

        $('#' + this.actionPermissionType).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'UIAction/GetPermReqType?subtype=' + this.selectedField.storedItem.SubType + '&type=' + this.selectedField.storedItem.Type + '&parentType=' + this.objectType;
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            },
            dataBound: (e) => {
                if (e.sender.value() == null || (e.sender.value() != null && e.sender.dataSource.data().filter(row => { return row.Id == e.sender.value() }).length == 0)) {
                    e.sender.value(e.sender.dataSource.data()[0].Id);
                }
            }
        });

        if (this.selectedField.storedItem.PermReqType != null && $('#' + this.actionPermissionType).data('kendoComboBox') != null) {
            $('#' + this.actionPermissionType).data('kendoComboBox').value(this.selectedField.storedItem.PermReqType);
        }

        $('#' + this.actionList).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityList/GetList';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if (this.selectedField.storedItem.IdListTarget != null && this.selectedField.storedItem.IdListTarget != 0) {
            $('#' + this.actionList).data('kendoComboBox').value(this.selectedField.storedItem.IdListTarget);
        }

        $('#' + this.actionSubForm).kendoComboBox({
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'EntityForm/GetForm';
                        }
                    }
                }
            },
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if (this.selectedField.storedItem.IdFormTarget != null && this.selectedField.storedItem.IdFormTarget != 0) {
            $('#' + this.actionSubForm).data('kendoComboBox').value(this.selectedField.storedItem.IdFormTarget);

            this.selectedField.storedItem.IsNormalForm = true;
        } else {
            if (this.uiFieldsControl != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdForm] != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdForm] != 0) {
                this.selectedField.storedItem.IsNormalForm = false;
            } else {
                this.selectedField.storedItem.IsNormalForm = true;
            }
        }

        $('#' + this.actionSubFormIdForm).kendoComboBox({
            dataTextField: 'Label',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getActionTargetColumns(),
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if (this.uiFieldsControl != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdForm] != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdForm] != 0) {
            $('#' + this.actionSubFormIdForm).data('kendoComboBox').value(this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdForm]);
        }

        $('#' + this.actionSubFormIdPkVal).kendoComboBox({
            dataTextField: 'Label',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getActionTargetColumns(),
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionFormIdPkVal).kendoComboBox({
            dataTextField: 'Label',
            dataValueField: 'Id',
            filter: 'contains',
            suggest: true,
            ignoreCase: true,
            dataSource: this._getActionTargetColumns(),
            change: (e) => {
                this.saveDetails();
                loadPreview();
            }
        });

        if (this.selectedField.storedItem.IsNormalForm) {
            if (this.uiFieldsControl != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdPkVal] != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdPkVal] != 0) {
                $('#' + this.actionFormIdPkVal).data('kendoComboBox').value(this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdPkVal]);
            }
        } else {
            if (this.uiFieldsControl != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdPkVal] != null && this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdPkVal] != 0) {
                $('#' + this.actionSubFormIdPkVal).data('kendoComboBox').value(this.selectedField.storedItem[this.uiFieldsControl.actionSubFormIdPkVal]);
            }
        }


        $('#' + this.actionNormalForm).kendoSwitch({
            messages: {
                checked: this.getResource('SWITCH_ON'),
                unchecked: this.getResource('SWITCH_OFF')
            },
            checked: this.selectedField.storedItem.IsNormalForm,
            change: (e) => {
                if (e.checked) {
                    $('#' + this.actionSubFormIdForm).data('kendoComboBox').value(null);
                    $('#' + this.actionSubFormIdPkVal).data('kendoComboBox').value(null);
                    $('#' + this.actionDynamicContentForm).show();
                    $('#' + this.actionDynamicContentFormId).hide();
                } else {
                    $('#' + this.actionSubForm).data('kendoComboBox').value(null);
                    $('#' + this.actionFormIdPkVal).data('kendoComboBox').value(null);
                    $('#' + this.actionDynamicContentFormId).show();
                    $('#' + this.actionDynamicContentForm).hide();
                }

                this.saveDetails();
                loadPreview();
            }
        });

        $('#' + this.actionNewRecord).kendoSwitch({
            messages: {
                checked: this.getResource('SWITCH_ON'),
                unchecked: this.getResource('SWITCH_OFF')
            },
            checked: this.selectedField.storedItem.NewRecord == null ? false : this.selectedField.storedItem.NewRecord,
            change: (e) => {
                if (e.checked) {
                    this.selectedField.storedItem.NewRecord = true;
                    $('#' + this.actionNewFormMappings).show();
                    $('#' + this.actionSubFormIdPkVal).parent().parent().hide();
                    $('#' + this.actionFormIdPkVal).parent().parent().hide();
                } else {
                    this.selectedField.storedItem.NewRecord = false;
                    $('#' + this.actionNewFormMappings).hide();
                    $('#' + this.actionSubFormIdPkVal).parent().parent().show();
                    $('#' + this.actionFormIdPkVal).parent().parent().show();
                }

                this.saveDetails();
                loadPreview();
            }
        });

        if (this.selectedField.storedItem.Type == 'STANDARD_GENERAL' || this.selectedField.storedItem.Type == 'DYNAMIC_GENERAL') {
            if ($('#' + this.actionNormalForm).data('kendoSwitch') != null) {
                $('#' + this.actionNormalForm).data('kendoSwitch').check(true);
                $('#' + this.actionNormalForm).data('kendoSwitch').enable(false);
                $('#' + this.actionSubFormIdForm).data('kendoComboBox').value(null);
                $('#' + this.actionSubFormIdPkVal).data('kendoComboBox').value(null);
                $('#' + this.actionDynamicContentForm).show();
                $('#' + this.actionDynamicContentFormId).hide();
            }

            if ($('#' + this.actionNewRecord).data('kendoSwitch') != null) {
                $('#' + this.actionNewRecord).data('kendoSwitch').check(true);
                $('#' + this.actionNewRecord).data('kendoSwitch').enable(false);

                this.selectedField.storedItem.NewRecord = true;
                $('#' + this.actionNewFormMappings).show();
                $('#' + this.actionSubFormIdPkVal).parent().parent().hide();
                $('#' + this.actionFormIdPkVal).parent().parent().hide();
            }
        }

        if (this.selectedField.storedItem.NewRecord) {
            $('#' + this.actionNewFormMappings).show();
            $('#' + this.actionSubFormIdPkVal).parent().parent().hide();
            $('#' + this.actionFormIdPkVal).parent().parent().hide();
        } else {
            $('#' + this.actionSubFormIdPkVal).parent().parent().show();
            $('#' + this.actionFormIdPkVal).parent().parent().show();
        }

        if (this.selectedField.storedItem.IsNormalForm) {
            $('#' + this.actionDynamicContentForm).show();
            $('#' + this.actionDynamicContentFormId).hide();
        } else {
            $('#' + this.actionDynamicContentFormId).show();
            $('#' + this.actionDynamicContentForm).hide();
        }

        if (this.selectedField.storedItem.SubType == 'SPATIAL_ANALYSIS') {
            this._initAnalysisConfig(this.selectedField);
        }

        if (this.selectedField.storedItem.SubType == 'PRINTING') {
            this._initPrintingConfig(this.selectedField);
        }

        if (this.selectedField.storedItem.Id == 0) {
            if (this.type == 'form') {
                switch (this.selectedField.storedItem.SubType) {
                    case 'EDIT_GEOMETRY': {
                        $('#' + this.actionClassName).data('kendoComboBox').value('ml-2 btn-info');
                        $('#' + this.actionIcon).data('kendoComboBox').value('fal fa-map-marker-edit');
                        break;
                    }
                    case 'SHOW_IN_MAP': {
                        $('#' + this.actionClassName).data('kendoComboBox').value('ml-2 btn-info');
                        $('#' + this.actionIcon).data('kendoComboBox').value('fal fa-map-marked-alt');
                        break;
                    }
                    case 'FORM': {
                        $('#' + this.actionClassName).data('kendoComboBox').value('ml-2 btn-primary');
                        $('#' + this.actionIcon).data('kendoComboBox').value('fal fa-file-alt');
                        break;
                    }
                    case 'URL': {
                        $('#' + this.actionClassName).data('kendoComboBox').value('ml-2 btn-info');
                        $('#' + this.actionIcon).data('kendoComboBox').value('fal fa-external-link-alt');
                        break;
                    }
                    case 'JS': {
                        $('#' + this.actionClassName).data('kendoComboBox').value('ml-2 btn-info');
                        $('#' + this.actionIcon).data('kendoComboBox').value('fal fa-cog');
                        break;
                    }
                    case 'FormWf': {
                        $('#' + this.actionClassName).data('kendoComboBox').value('ml-2 btn-primary');
                        $('#' + this.actionIcon).data('kendoComboBox').value('fal fa-file-alt');
                        break;
                    }
                }

                this.saveDetails();
                loadPreview();
            }
        }
        addHelp();
    }

    saveGeneralDetails() {
        let item = {};

        item.Content = this.selectedField.storedItem.Content;
        item.InvalidProperties = this.selectedField.storedItem.InvalidProperties;
        item.Id = this.selectedField.storedItem.Id;
        item.Type = this.selectedField.storedItem.Type;

        if ($('#' + this.actionModalHeight).length > 0 && $('#' + this.actionModalWidth).length > 0) {
            let uiContent = {
                modalHeight: $('#' + this.actionModalHeight).val(),
                modalWidth: $('#' + this.actionModalWidth).val(),
                isAlwaysModal: $('#' + this.actionAlwaysModal).data('kendoSwitch').check()
            };

            item.UiContent = JSON.stringify(uiContent);
        }

        if ($('#' + this.actionShowInQuickLegend).length > 0) {
            let content = {
                showInQuickLegend: $('#' + this.actionShowInQuickLegend).data('kendoSwitch').check()
            };

            item.Content = JSON.stringify(content);
        }

        if (item.Type == 'DYNAMIC_GENERAL') {
            if ($('#' + this.actionType).data('kendoComboBox') != null) {
                let subType = $('#' + this.actionType).data('kendoComboBox').value();

                if (subType == null || subType == '') {
                    subType = null;
                }

                item.SubType = subType;
            } else {
                item.SubType = this.selectedField.storedItem.SubType;
            }

            let permissionType = $('#' + this.actionPermissionType).data('kendoComboBox') == null ? null : $('#' + this.actionPermissionType).data('kendoComboBox').value();

            item.PermReqType = permissionType;

            let platforms = this._getPlatform($('#' + this.actionPlatforms).data('kendoMultiSelect'));
            item.Platforms = platforms;

            let form = $('#' + this.actionSubForm).data('kendoComboBox') == null ? null : $('#' + this.actionSubForm).data('kendoComboBox').value();

            if (form != null && form != '') {
                item.IdFormTarget = this.getNumber(form);
            }

            let plugin = $('#' + this.actionPlugin).data('kendoComboBox') == null ? null : $('#' + this.actionPlugin).data('kendoComboBox').value();

            if (plugin != null && plugin != '' && item.SubType == 'PLUGIN') {
                item.Content = plugin;
            }

            let dashboard = $('#' + this.actionDashboard).data('kendoComboBox') == null ? null : $('#' + this.actionDashboard).data('kendoComboBox').value();

            if (dashboard != null && dashboard != '') {
                item.IdDashboardTarget = dashboard;
            }

            let report = $('#' + this.actionReport).data('kendoComboBox') == null ? null : $('#' + this.actionReport).data('kendoComboBox').value();

            if (report != null && report != '') {
                item.IdDevExRptTarget = report;
            }

            if (item.SubType == "SPATIAL_ANALYSIS" && $('#' + this.actionAnalysisResultType).length > 0) {
                let analysisConfig = {};
                analysisConfig.resultType = $('#' + this.actionAnalysisResultType).data('kendoComboBox').value();
                analysisConfig.operatorType = $('#' + this.actionAnalysisOperatorType).data('kendoComboBox').value();
                analysisConfig.selectorStyle = $('#' + this.actionAnalysisSelectorStyle).data('kendoComboBox').value();
                analysisConfig.resultStyle = $('#' + this.actionAnalysisResultStyle).data('kendoComboBox').value();
                analysisConfig.quickSearch = $('#' + this.actionAnalysisQuickSearch).data('kendoComboBox').value();
                analysisConfig.buffer = $('#' + this.actionAnalysisBuffer).val();
                analysisConfig.header = this.htmlMainEditorHeader.getValue();
                analysisConfig.footer = this.htmlMainEditorFooter.getValue();

                item.Content = JSON.stringify(analysisConfig);

                item.ActionLayers = $('#' + this.actionAnalysisLayers).data('kendoGrid').dataSource.data().toJSON();
            }

            if (item.SubType == "PRINTING" && $('#' + this.actionPrintingPageType).length > 0) {
                let printingConfig = {};
                printingConfig.pageType = $('#' + this.actionPrintingPageType).data('kendoComboBox').value();
                printingConfig.pageOrientation = $('#' + this.actionPrintingPageOrientation).data('kendoComboBox').value();
                printingConfig.template = this.htmlPrintingTemplate.getValue();
                item.Content = JSON.stringify(printingConfig);
            }
        } else {
            item.SubType = this.selectedField.storedItem.SubType;

            let permissionType = $('#' + this.actionPermissionType).data('kendoComboBox') == null ? null : $('#' + this.actionPermissionType).data('kendoComboBox').value();

            item.PermReqType = permissionType;

            let platforms = this._getPlatform($('#' + this.actionPlatforms).data('kendoMultiSelect'));
            item.Platforms = platforms;


            let form = $('#' + this.actionForm).data('kendoComboBox') == null ? null : $('#' + this.actionForm).data('kendoComboBox').value();

            if (form != null && form != '') {
                item.IdFormTarget = this.getNumber(form);
            }

            let plugin = $('#' + this.actionPlugin).data('kendoComboBox') == null ? null : $('#' + this.actionPlugin).data('kendoComboBox').value();

            if (plugin != null && plugin != '') {
                item.Content = plugin;
            }

            let dashboard = $('#' + this.actionDashboard).data('kendoComboBox') == null ? null : $('#' + this.actionDashboard).data('kendoComboBox').value();

            if (dashboard != null && dashboard != '') {
                item.IdDashboardTarget = dashboard;
            }

            let report = $('#' + this.actionReport).data('kendoComboBox') == null ? null : $('#' + this.actionReport).data('kendoComboBox').value();

            if (report != null && report != '') {
                item.IdDevExRptTarget = report;
            }

            if (item.SubType == "Timeline") {
                let timelineConfig = {};
                timelineConfig.type = $('#' + this.actionTimelineType).data('kendoComboBox').value();
                timelineConfig.unit = $('#' + this.actionTimelineUnit).data('kendoComboBox').value();
                timelineConfig.start = $("#" + this.actionTimelineStart).data('kendoDateTimePicker').value();
                timelineConfig.end = $("#" + this.actionTimelineEnd).data('kendoDateTimePicker').value();
                timelineConfig.periodType = $('#' + this.actionTimelineIntervalPeriodType).data('kendoComboBox').value();
                timelineConfig.periodLength = $('#' + this.actionTimelineIntervalPeriodLength).val();
                timelineConfig.format = $('#' + this.actionTimelineFormat).val();
                timelineConfig.loop = $('#' + this.actionTimelineLoop).data('kendoSwitch').check();
                timelineConfig.intervalType = $('#' + this.actionTimelineIntervalType).data('kendoSwitch').check();
                timelineConfig.selectorType = $('#' + this.actionTimelineSelectorType).data('kendoComboBox').value();
                timelineConfig.background = $('#' + this.actionTimelineBackground).val();
                timelineConfig.channel = $('#' + this.actionTimelineChannel).val();
                timelineConfig.thumb = $('#' + this.actionTimelineThumb).val();
                timelineConfig.speed = $('#' + this.actionTimelineSpeed).val();
                item.Content = JSON.stringify(timelineConfig);
            }

            if (item.SubType == "FollowUserPosition") {
                let followUserPositionConfig = {};
                followUserPositionConfig.zoom = $('#' + this.actionFollowZoom).val();
                followUserPositionConfig.autoDisableOnMapPan = $('#' + this.actionFollowDisable).data('kendoSwitch').check();
                followUserPositionConfig.initiallyEnabled = $('#' + this.actionFollowEnabled).data('kendoSwitch').check();
                item.Content = JSON.stringify(followUserPositionConfig);
            }
        }

        if (this.type == 'application' && this.subType == 'app' && this.selectedField.storedItem.SubType != 'JS' && $('#' + this.actionLoadOnStart).data('kendoSwitch') != null) {
            item.LoadOnStart = $('#' + this.actionLoadOnStart).data('kendoSwitch').check();
        }

        let actionText = $('#' + this.actionText).val();

        item.Text = actionText;
        item.Icon = $('#' + this.actionIcon).data('kendoComboBox') == null ? null : $('#' + this.actionIcon).data('kendoComboBox').value();
        item.IconMobile = $('#' + this.actionMobileIcon).data('kendoComboBox') == null ? null : $('#' + this.actionMobileIcon).data('kendoComboBox').value();
        item.Title = $('#' + this.actionTooltip).val();

        if ($('#' + this.actionClassName).data('kendoComboBox').value() != null && $('#' + this.actionClassName).data('kendoComboBox').value() != '') {
            item.ClassName = $('#' + this.actionClassName).data('kendoComboBox').value();
        } else {
            item.ClassName = $('#' + this.actionClassName).data('kendoComboBox').text();
        }

        if (this.jsEditor != null && this.jsEditor.getValue() != '') {
            item.Js = this.jsEditor.getValue();
        }

        let url = $('#' + this.actionUrl).val();

        if (url != null && url != '') {
            item.Url = url;
        }

        let formWfFields = $('#' + this.actionFormWfFormFields).data('kendoMultiSelect') == null ? null : $('#' + this.actionFormWfFormFields).data('kendoMultiSelect').value();

        if (formWfFields != null && formWfFields != '') {
            item.Content = JSON.stringify(formWfFields);
        } else {
            if (item.SubType == 'FormWf') {
                item.Content = JSON.stringify([]);
            }
        }

        let list = $('#' + this.actionList).data('kendoComboBox') == null ? null : $('#' + this.actionList).data('kendoComboBox').value();

        if (list != null && list != '') {
            item.IdListTarget = this.getNumber(list);
        }

        item.Style = this.selectedField.storedItem.Style;

        item.HtmlAttributes = this.selectedField.storedItem.HtmlAttributes;

        if (item.PermReqType == null) {
            item.PermReqType = 0;
        }

        this.selectedField.storedItem = item;
    }

    saveElementDetails() {
        let item = {};

        item.InvalidProperties = this.selectedField.storedItem.InvalidProperties;
        item.Id = this.selectedField.storedItem.Id;
        item.Type = this.selectedField.storedItem.Type;

        if ($('#' + this.actionModalHeight).length > 0 && $('#' + this.actionModalWidth).length > 0) {
            let uiContent = {
                modalHeight: $('#' + this.actionModalHeight).val(),
                modalWidth: $('#' + this.actionModalWidth).val(),
                isAlwaysModal: $('#' + this.actionAlwaysModal).data('kendoSwitch').check()
            };

            item.UiContent = JSON.stringify(uiContent);
        }

        if (item.Type == 'DYNAMIC_ELEMENT') {
            let subType = $('#' + this.actionType).data('kendoComboBox') == null ? null : $('#' + this.actionType).data('kendoComboBox').value();

            if (subType == null || subType == '') {
                subType = null;
            }

            item.SubType = subType;

            let permissionType = $('#' + this.actionPermissionType).data('kendoComboBox') == null ? null : $('#' + this.actionPermissionType).data('kendoComboBox').value();

            item.PermReqType = permissionType;

            let platforms = this._getPlatform($('#' + this.actionPlatforms).data('kendoMultiSelect'));
            item.Platforms = platforms;

            let form = $('#' + this.actionSubForm).data('kendoComboBox') == null ? null : $('#' + this.actionSubForm).data('kendoComboBox').value();

            if (form != null && form != '') {
                item.IdFormTarget = this.getNumber(form);
            }

            let formIdForm = $('#' + this.actionSubFormIdForm).data('kendoComboBox') == null ? null : $('#' + this.actionSubFormIdForm).data('kendoComboBox').value();

            if (formIdForm != null && formIdForm != '') {
                item[this.uiFieldsControl.actionSubFormIdForm] = this.getNumber(formIdForm);
            }

            let formIdPkVal = null;

            if ($('#' + this.actionNormalForm).data('kendoSwitch') == null || $('#' + this.actionNormalForm).data('kendoSwitch').check()) {
                formIdPkVal = $('#' + this.actionFormIdPkVal).data('kendoComboBox') == null ? null : $('#' + this.actionFormIdPkVal).data('kendoComboBox').value();
            } else {
                formIdPkVal = $('#' + this.actionSubFormIdPkVal).data('kendoComboBox') == null ? null : $('#' + this.actionSubFormIdPkVal).data('kendoComboBox').value();
            }

            if (formIdPkVal != null && formIdPkVal != '') {
                item[this.uiFieldsControl.actionSubFormIdPkVal] = this.getNumber(formIdPkVal);
            }

            let geomField = $('#' + this.actionGeomField).data('kendoComboBox') == null ? null : $('#' + this.actionGeomField).data('kendoComboBox').value();

            if (geomField != null && form != '') {
                if (geomField)
                    item.IdFieldTarget = this.getNumber(geomField);
            }

            let plugin = $('#' + this.actionPlugin).data('kendoComboBox') == null ? null : $('#' + this.actionPlugin).data('kendoComboBox').value();

            if (plugin != null && plugin != '') {
                item.Content = plugin;
            }

            let dashboard = $('#' + this.actionDashboard).data('kendoComboBox') == null ? null : $('#' + this.actionDashboard).data('kendoComboBox').value();

            if (dashboard != null && dashboard != '') {
                item.IdDashboardTarget = dashboard;
            }

            let report = $('#' + this.actionReport).data('kendoComboBox') == null ? null : $('#' + this.actionReport).data('kendoComboBox').value();

            if (report != null && report != '') {
                item.IdDevExRptTarget = report;
            }
        } else {
            item.SubType = this.selectedField.storedItem.SubType;

            let permissionType = $('#' + this.actionPermissionType).data('kendoComboBox') == null ? null : $('#' + this.actionPermissionType).data('kendoComboBox').value();
            item.PermReqType = permissionType;

            let platforms = this._getPlatform($('#' + this.actionPlatforms).data('kendoMultiSelect'));
            item.Platforms = platforms;

            let form = $('#' + this.actionForm).data('kendoComboBox') == null ? null : $('#' + this.actionForm).data('kendoComboBox').value();

            if (form != null && form != '') {
                item.IdFormTarget = this.getNumber(form);
            }

            let geomField = $('#' + this.actionGeomField).data('kendoComboBox') == null ? null : $('#' + this.actionGeomField).data('kendoComboBox').value();

            if (geomField != null && form != '') {
                item.IdFieldTarget = this.getNumber(geomField);
            }

            let plugin = $('#' + this.actionPlugin).data('kendoComboBox') == null ? null : $('#' + this.actionPlugin).data('kendoComboBox').value();

            if (plugin != null && plugin != '') {
                item.Content = plugin;
            }

            let dashboard = $('#' + this.actionDashboard).data('kendoComboBox') == null ? null : $('#' + this.actionDashboard).data('kendoComboBox').value();

            if (dashboard != null && dashboard != '') {
                item.IdDashboardTarget = dashboard;
            }

            let report = $('#' + this.actionReport).data('kendoComboBox') == null ? null : $('#' + this.actionReport).data('kendoComboBox').value();

            if (report != null && report != '') {
                item.IdDevExRptTarget = report;
            }
        }

        let actionText = $('#' + this.actionText).val();

        item.Text = actionText;
        item.Icon = $('#' + this.actionIcon).data('kendoComboBox') == null ? null : $('#' + this.actionIcon).data('kendoComboBox').value();
        item.IconMobile = $('#' + this.actionMobileIcon).data('kendoComboBox') == null ? null : $('#' + this.actionMobileIcon).data('kendoComboBox').value();
        item.Title = $('#' + this.actionTooltip).val();

        if ($('#' + this.actionClassName).data('kendoComboBox').value() != null && $('#' + this.actionClassName).data('kendoComboBox').value() != '') {
            item.ClassName = $('#' + this.actionClassName).data('kendoComboBox').value();
        } else {
            item.ClassName = $('#' + this.actionClassName).data('kendoComboBox').text();
        }

        if ($('#' + this.actionMinSelection).data('kendoNumericTextBox') != null) {
            item.MinSel = $('#' + this.actionMinSelection).data('kendoNumericTextBox').value();
        }

        if ($('#' + this.actionMaxSelection).data('kendoNumericTextBox') != null) {
            item.MaxSel = $('#' + this.actionMaxSelection).data('kendoNumericTextBox').value();
        }

        if (this.jsEditor != null && this.jsEditor.getValue() != '') {
            item.Js = this.jsEditor.getValue();
        }

        let url = $('#' + this.actionUrl).val();

        if (url != null && url != '') {
            item.Url = url;
        }

        let formWfFields = $('#' + this.actionFormWfFormFields).data('kendoMultiSelect') == null ? null : $('#' + this.actionFormWfFormFields).data('kendoMultiSelect').value();

        if (formWfFields != null && formWfFields != '') {
            this.selectedField.storedItem.Content = JSON.stringify(formWfFields);
        } else {
            if (this.selectedField.storedItem.SubType == 'FormWf') {
                this.selectedField.storedItem.Content = JSON.stringify([]);
            }
        }

        let list = $('#' + this.actionList).data('kendoComboBox') == null ? null : $('#' + this.actionList).data('kendoComboBox').value();

        if (list != null && list != '') {
            item.IdListTarget = this.getNumber(list);
        }

        item.Style = this.selectedField.storedItem.Style;

        item.HtmlAttributes = this.selectedField.storedItem.HtmlAttributes;
        item.Content = this.selectedField.storedItem.Content;
        item.NewRecord = this.selectedField.storedItem.NewRecord;

        if (item.PermReqType == null) {
            item.PermReqType = 0;
        }

        this.selectedField.storedItem = item;
    }

    saveItems() {
        this.saveDetails();
        let data = {
            id: this.objectId,
            parentType: this.objectType,
            elementItems: null,
            generalItems: null
        };

        if (this.type == 'list' || this.type == 'layer' || this.type == 'mapLayer') {
            data.generalItems = this.saveGeneralItems();
            data.elementItems = this.saveElementItems();
        } else if (this.type == 'application' || this.type == 'map') {
            data.generalItems = this.saveGeneralItems();
        } else {
            data.elementItems = this.saveElementItems();
        }

        let saveUrl = rootUrl + 'UIAction/SaveActions'

        $.ajax({
            type: "POST",
            url: saveUrl,
            async: true,
            data: JSON.stringify(data),
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                this.hasErrors = false;
                this.initTree();
            },
            error: (e) => {
                toastr.error(this.getResource('SaveError'));
            }
        });
    }

    _getGeneralActions() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        let fieldNodes = null;
        if (fieldParentNode != null && fieldParentNode.children != null) {
            fieldNodes = fieldParentNode.children.data();
        }


        let fieldData = [];

        if (fieldNodes != null) {
            fieldNodes.forEach(fieldNode => {
                if (fieldNode.checked) {
                    fieldData.push(fieldNode.storedItem);
                }
            });
        }

        let data = {
            items: fieldData,
            id: this.objectId,
            parentType: this.objectType
        }

        return data;
    }

    saveGeneralItems() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 1 })[0];

        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];
        this._storeItemTree(fieldNodes, fieldData);

        return fieldData;
    }

    _storeItemTree(nodes, result) {
        nodes.forEach(node => {
            if (node.checked) {
                let item = node.storedItem;
                item.Items = [];
                result.push(item);

                if (node.Items.length > 0) {
                    this._storeItemTree(node.Items, item.Items);
                }
            }
        });
    }

    _getElementActions() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 2 })[0];

        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];

        fieldNodes.forEach(fieldNode => {
            if (fieldNode.checked) {
                fieldData.push(fieldNode.storedItem);
            }
        });

        let data = {
            items: fieldData,
            id: this.objectId,
            parentType: this.objectType
        }

        return data;
    }

    _validateAction(item) {
        if (item != null && item.InvalidProperties != null && item.InvalidProperties.length > 0) {
            item.InvalidProperties.forEach(property => {
                if ($('#' + property.PropertyName + '-validation').length > 0) {
                    $('#' + property.PropertyName + '-validation')[0].innerHTML = property.Message;
                }
            });
        }
    }

    saveElementItems() {
        let fieldParentNode = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().filter(action => { return action.id == 2 })[0];

        let fieldNodes = fieldParentNode.children.data();

        let fieldData = [];

        fieldNodes.forEach(fieldNode => {
            if (fieldNode.checked) {
                fieldData.push(fieldNode.storedItem);
            }
        });

        return fieldData;
    }

    /* Templates */
    getDynamicTemplate(item) {
        let template = ``;

        if ((item.type == 'DYNAMIC_GENERAL' || item.type == 'DYNAMIC_ELEMENT') && !(item.subType == 'GROUP' || item.subType == 'SEPARATOR')) {
            template = `<div class="form-row">
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionType') + `</label>
                                    <div id="` + this.actionType + `" class="form-control"></div>
                                    <span id="SubType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                        </div>`;
        }

        return template;
    }

    getElementActionDefinitionTemplate(item) {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.actionTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow-y: auto; overflow-x:hidden;">
                            <div class="action-definition-content col-12">` +
            this.getDynamicTemplate(item)
            + `<div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionText') + `</label>
                                            <input type="text" id="` + this.actionText + `" class="form-control" autocomplete="off"/>
                                            <span id="Text-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionTooltip') + `</label>
                                            <input type="text" id="` + this.actionTooltip + `" class="form-control" autocomplete="off"/>
                                            <span id="Title-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                 </div>
                                 <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionIcon') + `</label>
                                            <div id="` + this.actionIcon + `" class="form-control"></div>
                                            <span id="Icon-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionMobileIcon') + `</label>
                                            <div id="` + this.actionMobileIcon + `" class="form-control"></div>
                                            <span id="IconMobile-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>` +
            this.getSpecificElementActionTemplate(item)
            + `<div class="form-row" id="` + this.actionDynamicContent + `">
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('Platforms') + `</label>
                                            <div id="` + this.actionPlatforms + `" class="form-control"></div>
                                            <span id="Platforms-validation" class="field-error-message"></span>
                                        </div>
                                    </div>                        
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ClassName') + `</label>
                                            <div id="` + this.actionClassName + `" class="form-control"></div>
                                            <span id="ClassName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group mb-1">
                                            <button id="` + this.actionStyle + `" class="btn btn-primary" title="` + this.getResource('Style') + `" type="button">` + this.getResource('Style') + `</button>
                                            <button id="` + this.actionHtmlAttributes + `" class="btn btn-primary ml-2" title="` + (item.storedItem.SubType == 'DEX_EX_RPT' ? this.getResource('ReportParams') : this.getResource('HtmlAttributes')) + `" type="button">` + (item.storedItem.SubType == 'DEX_EX_RPT' ? this.getResource('ReportParams') : this.getResource('HtmlAttributes')) + `</button>
                                            <button style="display:none;" id="` + this.actionNewFormMappings + `" class="btn btn-primary ml-2" title="` + this.getResource('NewFormMappings') + `" type="button">` + this.getResource('NewFormMappings') + `</button>
                                        </div>
                                        <span id="Style-validation" class="field-error-message"></span>
                                        <span id="HtmlAttributes-validation" class="field-error-message"></span>
                                        <span id="PrefilledFields-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    getSpecificElementActionTemplate(item) {
        if (item.subType == 'DYNAMIC_ELEMENT') {
            return ``;
        }

        let template = ``;

        switch (item.storedItem.SubType) {
            case "EDIT": {
                if (this.type == 'layer' || this.type == 'mapLayer') {
                    template += `<div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionMinSelection') + `</label>
                                            <input id="` + this.actionMinSelection + `" class="form-control"/>
                                            <span id="MinSel-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionMaxSelection') + `</label>
                                            <input id="` + this.actionMaxSelection + `" class="form-control"/>
                                            <span id="MaxSel-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>`;
                }
                template += `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionForm') + `</label>
                                <div id="` + this.actionForm + `" class="form-control"></div>
                                <span id="IdFormTarget-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                <span id="ModalHeight-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                <span id="ModalWidth-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                <div id="` + this.actionAlwaysModal + `"></div>
                                <span id="AlwaysModal-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
            }
                break;
            case "SHOW_IN_MAP": {
                template = `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('GeometryField') + `</label>
                                <div id="` + this.actionGeomField + `" class="form-control"></div>
                                <span id="IdFieldTarget-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
            }
                break;
            case "EDIT_GEOMETRY": {
                template = `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('GeometryField') + `</label>
                                <div id="` + this.actionGeomField + `" class="form-control"></div>
                                <span id="IdFieldTarget-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
            }
                break;
            default: {
                if (this.type == 'layer' || this.type == 'mapLayer') {
                    template += `<div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionMinSelection') + `</label>
                                            <input id="` + this.actionMinSelection + `" class="form-control"/>
                                            <span id="MinSel-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionMaxSelection') + `</label>
                                            <input id="` + this.actionMaxSelection + `" class="form-control"/>
                                            <span id="MaxSel-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>`;
                }

                if (item.storedItem.SubType != null && item.storedItem.SubType.trim() != '' && item.type != 'DYNAMIC_ELEMENT') {
                    template += `<div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                            <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                            <span id="PermReqType-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>`;
                }
            }
                break;
        }

        return template;
    }

    getDynamicActionTemplate(item) {
        let template = ``;

        switch (item.storedItem.SubType) {
            case "LIST": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionList') + `</label>
                                    <div id="` + this.actionList + `" class="form-control"></div>
                                    <span id="IdListTarget-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                    <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                    <span id="ModalHeight-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                    <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                    <span id="ModalWidth-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                    <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                    <div id="` + this.actionAlwaysModal + `"></div>
                                    <span id="AlwaysModal-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "FORM": {
                template += `<div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionStandardForm') + `</label>
                                    <div id="` + this.actionNormalForm + `"></div>
                                    <span id="IsNormalForm-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionNewRecord') + `</label>
                                    <div id="` + this.actionNewRecord + `"></div>
                                    <span id="NewRecord-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div id="` + this.actionDynamicContentForm + `" class="form-row col-12 ml-0 p-0">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this.getResource('ActionForm') + `</label>
                                        <div id="` + this.actionSubForm + `" class="form-control"></div>
                                        <span id="IdFormTarget-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this.getResource('ActionFormObjectId') + `</label>
                                        <div id="` + this.actionFormIdPkVal + `" class="form-control"></div>
                                    </div>
                                </div>
                            </div>
                            <div id="` + this.actionDynamicContentFormId + `" class="form-row col-12 ml-0 p-0">
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this.getResource('ActionFormId') + `</label>
                                        <div id="` + this.actionSubFormIdForm + `" class="form-control"></div>
                                    <span id="IdFormFieldTarget-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <div class="form-group">
                                        <label class="form-label">` + this.getResource('ActionFormObjectId') + `</label>
                                        <div id="` + this.actionSubFormIdPkVal + `" class="form-control"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                    <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                    <span id="ModalHeight-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                    <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                    <span id="ModalWidth-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                    <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                    <div id="` + this.actionAlwaysModal + `"></div>
                                    <span id="AlwaysModal-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "URL": {
                template += `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionUrl') + `</label>
                                    <input type="text" id="` + this.actionUrl + `" class="form-control"/>
                                    <span id="Url-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                    <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                    <span id="ModalHeight-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                    <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                    <span id="ModalWidth-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                    <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                    <div id="` + this.actionAlwaysModal + `"></div>
                                    <span id="AlwaysModal-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "FormWf": {
                template += `<div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>` + (this.type != 'application' ? `<div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionFormWfFormFields') + `</label>
                                    <div id="` + this.actionFormWfFormFields + `" class="form-control"></div>
                                </div>
                            </div>` : ``)
                         + `<div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionUrl') + `</label>
                                    <input type="text" id="` + this.actionUrl + `" class="form-control"/>
                                    <span id="Url-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                    <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                    <span id="ModalHeight-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                    <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                    <span id="ModalWidth-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                    <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                    <div id="` + this.actionAlwaysModal + `"></div>
                                    <span id="AlwaysModal-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "JS": {
                var helpKey = 'help-key="';
                if (this.type == "form") {
                    helpKey += 'Action.EntityForm.JavaScript';
                }
                else if (this.type == "list" && item.type =="DYNAMIC_GENERAL") {
                    helpKey += 'Action.EntityList.General.JavaScript';
                }
                else if (this.type == "list" && item.type == "DYNAMIC_ELEMENT") {
                    helpKey += 'Action.EntityList.Element.JavaScript';
                }
                else {
                    helpKey = "";
                }
                if (helpKey != "") {
                    helpKey += '"';
                }
                template += `<div class="col-sm-12 mb-3 pr-1 pl-1">
                                <div class="form-group">
                                    <label class="form-label" ` + helpKey + `>` + this.getResource('ActionJs') + `</label>
                                    <div id="` + this.actionJs + `" class="form-control" style="height: 6rem;"></div>
                                    <span id="Js-validation" class="field-error-message"></span>
                                </div>
                            </div>
                           <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "SHOW_IN_MAP": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('GeometryField') + `</label>
                                    <div id="` + this.actionGeomField + `" class="form-control"></div>
                                    <span id="IdFieldTarget-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "EDIT_GEOMETRY": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('GeometryField') + `</label>
                                    <div id="` + this.actionGeomField + `" class="form-control"></div>
                                    <span id="IdFieldTarget-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "IMPORT_EXCEL": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionForm') + `</label>
                                    <div id="` + this.actionSubForm + `" class="form-control"></div>
                                    <span id="IdFormTarget-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "PLUGIN": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPlugin') + `</label>
                                    <div id="` + this.actionPlugin + `" class="form-control"></div>
                                    <span id="Plugin-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "PRINTING": {
                template = `<div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('PrintingPageType') + `</label>
                                <div id="` + this.actionPrintingPageType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('PrintingPageOrientation') + `</label>
                                <div id="` + this.actionPrintingPageOrientation + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <label class="form-label">` + this.getResource('PrintingTemplate') + `</label>
                            <div class="form-control" id="` + this.actionPrintingTemplate + `" style="width: 100%; height: 200px;">
                            </div>
                        </div>`;
            }
                break;
            case "SPATIAL_ANALYSIS": {
                template = `<div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('AnalysisOperatorType') + `</label>
                                <div id="` + this.actionAnalysisOperatorType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('AnalysisBuffer') + `</label>
                                <input type="number" id="` + this.actionAnalysisBuffer + `" class="form-control" autocomplete="off"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('SelectorStyle') + `</label>
                                <div id="` + this.actionAnalysisSelectorStyle + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ResultStyle') + `</label>
                                <div id="` + this.actionAnalysisResultStyle + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('QuickSearch') + `</label>
                                <div id="` + this.actionAnalysisQuickSearch + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('AnalysisResultType') + `</label>
                                <div id="` + this.actionAnalysisResultType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('AnalysisLayers') + `</label>
                                <div id="` + this.actionAnalysisLayers + `" class="m-0"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <label class="form-label">` + this.getResource('TemplateHeader') + `</label>
                            <div class="form-control" id="` + this.actionAnalysisMainTemplateHeader + `" style="width: 100%; height: 200px;">
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <label class="form-label">` + this.getResource('TemplateFooter') + `</label>
                            <div class="form-control" id="` + this.actionAnalysisMainTemplateFooter + `" style="width: 100%; height: 200px;">
                            </div>
                        </div>`;
            }
                break;
            case "DASHBOARD": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('Dashboard') + `</label>
                                    <div id="` + this.actionDashboard + `" class="form-control"></div>
                                    <span id="IdDashboardTarget-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                    <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                    <span id="ModalHeight-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                    <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                    <span id="ModalWidth-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                    <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                    <div id="` + this.actionAlwaysModal + `"></div>
                                    <span id="AlwaysModal-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            case "DEX_EX_RPT": {
                template = `<div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('Report') + `</label>
                                    <div id="` + this.actionReport + `" class="form-control"></div>
                                    <span id="IdDevExRptTarget-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                    <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                    <span id="ModalHeight-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-6 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                    <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                    <span id="ModalWidth-validation" class="field-error-message"></span>
                                </div>
                            </div>
                            <div class="col-sm-12 mb-3">
                                <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                    <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                    <div id="` + this.actionAlwaysModal + `"></div>
                                    <span id="AlwaysModal-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
            }
                break;
            default: {
                if (item.storedItem.SubType != null && item.storedItem.SubType.trim() != '') {
                    template += ` <div class="col-sm-12 mb-3">
                                <div class="form-group">
                                    <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                    <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                    <span id="PermReqType-validation" class="field-error-message"></span>
                                </div>
                            </div>`;
                }
            }
                break;
        }

        if (this.type == 'application' && this.subType == 'app' && item.storedItem.SubType != 'JS') {
            template += `<div class="col-sm-3 mb-4" style="justify-content: center; display: flex; align-content: flex-end;  flex-wrap: wrap;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('LoadOnStart') + `</label>
                                <div id="` + this.actionLoadOnStart + `"></div>
                            </div>
                        </div>`;
        }

        return template;
    }

    getGeneralActionDefinitionTemplate(item) {
        let template = `<div class="form-row">
                            <div class="col-sm-12 d-flex align-items-center pb-2 border-bottom mb-3 ">
                                <h1 class="subheader-title ml-1 ml-lg-0 mt-2" id="` + this.actionTitle + `" style="font-size: 1rem;"></h1>
                            </div>
                        </div>
                        <div class="form-row" style="max-height: calc(100% - 3.3rem); overflow-y: auto; overflow-x:hidden;">
                            <div class="action-definition-content col-12">` +
            this.getDynamicTemplate(item)
            + `<div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionText') + `</label>
                                            <input type="text" id="` + this.actionText + `" class="form-control" autocomplete="off"/>
                                            <span id="Text-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionTooltip') + `</label>
                                            <input type="text" id="` + this.actionTooltip + `" class="form-control" autocomplete="off"/>
                                            <span id="Title-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                 </div>
                                 <div class="form-row">
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionIcon') + `</label>
                                            <div id="` + this.actionIcon + `" class="form-control"></div>
                                            <span id="Icon-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ActionMobileIcon') + `</label>
                                            <div id="` + this.actionMobileIcon + `" class="form-control"></div>
                                            <span id="IconMobile-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>` +
            this.getSpecificGeneralActionTemplate(item)
            + `<div class="form-row" id="` + this.actionDynamicContent + `">
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('Platforms') + `</label>
                                            <div id="` + this.actionPlatforms + `" class="form-control"></div>
                                            <span id="Platforms-validation" class="field-error-message"></span>
                                        </div>
                                    </div>                        
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group">
                                            <label class="form-label">` + this.getResource('ClassName') + `</label>
                                            <div id="` + this.actionClassName + `" class="form-control"></div>
                                            <span id="ClassName-validation" class="field-error-message"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-12 mb-3">
                                        <div class="form-group mb-1">
                                            <button id="` + this.actionStyle + `" class="btn btn-primary" title="` + this.getResource('Style') + `" type="button">` + this.getResource('Style') + `</button>
                                            <button id="` + this.actionHtmlAttributes + `" class="btn btn-primary ml-2" title="` + (item.storedItem.SubType == 'DEX_EX_RPT' ? this.getResource('ReportParams') : this.getResource('HtmlAttributes')) + `" type="button">` + (item.storedItem.SubType == 'DEX_EX_RPT' ? this.getResource('ReportParams') : this.getResource('HtmlAttributes')) + `</button>
                                        </div>
                                        <span id="Style-validation" class="field-error-message"></span>
                                        <span id="HtmlAttributes-validation" class="field-error-message"></span>
                                    </div>
                                </div>
                            </div>
                        </div>`;

        return template;
    }

    getSpecificGeneralActionTemplate(item) {
        let template = ``;

        switch (item.storedItem.SubType) {
            case "ADD": {
                template = `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label" help-key="UIAction.IdFormTarget.List.Add">` + this.getResource('ActionForm') + `</label>
                                <div id="` + this.actionForm + `" class="form-control"></div>
                                <span id="IdFormTarget-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                <span id="ModalHeight-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                <span id="ModalWidth-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                <div id="` + this.actionAlwaysModal + `"></div>
                                <span id="AlwaysModal-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        ` + (this.type == 'layer' || this.type == 'mapLayer' ? `
                        <div class="col-sm-12 mb-3">
                            <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                <label class="form-label mb-0 ml-1">` + this.getResource('ShowInQuickLegend') + `</label>
                                <div id="` + this.actionShowInQuickLegend + `"></div>
                                <span id="ShowInQuickLegend-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        ` : ``) + `
                    </div>`;
            }
                break;
            case "ADD_MULTI": {
                template = `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label" help-key="UIAction.IdFormTarget.List.Add">` + this.getResource('ActionForm') + `</label>
                                <div id="` + this.actionForm + `" class="form-control"></div>
                                <span id="IdFormTarget-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ModalHeight') + `</label>
                                <input type="text" id="` + this.actionModalHeight + `" class="form-control"/>
                                <span id="ModalHeight-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ModalWidth') + `</label>
                                <input type="text" id="` + this.actionModalWidth + `" class="form-control"/>
                                <span id="ModalWidth-validation" class="field-error-message"></span>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="form-group" style="flex-direction: row-reverse; align-content: start; display: flex; flex-wrap: wrap; justify-content: start;">
                                <label class="form-label mb-0 ml-1">` + this.getResource('ActionAlwaysModal') + `</label>
                                <div id="` + this.actionAlwaysModal + `"></div>
                                <span id="AlwaysModal-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
            }
                break;
            case "FollowUserPosition": {
                template = `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionFollowZoom') + `</label>
                                <input type="number" id="` + this.actionFollowZoom + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-3 mb-4" style="justify-content: center; display: flex; align-content: flex-end;  flex-wrap: wrap;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionFollowDisable') + `</label>
                                <div id="` + this.actionFollowDisable + `"></div>
                            </div>
                        </div>
                        <div class="col-sm-3 mb-4" style="justify-content: center; display: flex; align-content: flex-end;  flex-wrap: wrap;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionFollowEnabled') + `</label>
                                <div id="` + this.actionFollowEnabled + `"></div>
                            </div>
                        </div>
                    </div>
                `;
            }
                break;
            case "Timeline": {
                template = `
                    <div class="form-row">
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineType') + `</label>
                                <div id="` + this.actionTimelineType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineUnit') + `</label>
                                <div id="` + this.actionTimelineUnit + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineIntervalType') + `</label>
                                <div id="` + this.actionTimelineIntervalType + `"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3 action-timeline-def-interval" style="display: none;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineStart') + `</label>
                                <input id="` + this.actionTimelineStart + `" class="form-control" autocomplete="off"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3 action-timeline-def-interval" style="display: none;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineEnd') + `</label>
                                <input id="` + this.actionTimelineEnd + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3 action-timeline-cus-interval" style="display: none;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineIntervalPeriodType') + `</label>
                                <div id="` + this.actionTimelineIntervalPeriodType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3 action-timeline-cus-interval" style="display: none;">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineIntervalPeriodLength') + `</label>
                                <input id="` + this.actionTimelineIntervalPeriodLength + `" class="form-control" type="number"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineFormat') + `</label>
                                <input type="text" id="` + this.actionTimelineFormat + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineSelectorType') + `</label>
                                <div id="` + this.actionTimelineSelectorType + `" class="form-control"></div>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineBackground') + `</label>
                                <input type="text" id="` + this.actionTimelineBackground + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineChannel') + `</label>
                                <input type="text" id="` + this.actionTimelineChannel + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineThumb') + `</label>
                                <input type="text" id="` + this.actionTimelineThumb + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineSpeed') + `</label>
                                <input type="number" id="` + this.actionTimelineSpeed + `" class="form-control"/>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionTimelineLoop') + `</label>
                                <div id="` + this.actionTimelineLoop + `"></div>
                            </div>
                        </div>
                        <div class="col-sm-12 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
            }
                break;
            case "LIST": break;
            default: {
                if (item.storedItem.SubType != null && item.storedItem.SubType.trim() != null && item.storedItem.Type != 'DYNAMIC_GENERAL') {
                    template = `
                    <div class="form-row">
                        <div class="col-sm-12 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.getResource('ActionPermissionType') + `</label>
                                <div id="` + this.actionPermissionType + `" class="form-control"></div>
                                <span id="PermReqType-validation" class="field-error-message"></span>
                            </div>
                        </div>
                    </div>`;
                }
            }
                break;
        }

        return template;
    }

    /* Resources */

    getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }
}